(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3816],{

/***/ 28542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Abstracts_AddToCartButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/hooks/cart/useGetCart/index.tsx + 2 modules
var useGetCart = __webpack_require__(73371);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useAddCartLines/index.js + 1 modules
var useAddCartLines = __webpack_require__(25291);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/cart/useUpdateCartAttributes/index.js + 1 modules
var useUpdateCartAttributes = __webpack_require__(90646);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/UI/CartContent/CartItem/index.tsx
var CartItem = __webpack_require__(26880);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/providers/GlobalDataProvider/index.tsx
var GlobalDataProvider = __webpack_require__(11036);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/Toasts/CartToast/styles.module.scss
var styles_module = __webpack_require__(49166);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Toasts/CartToast/index.tsx
















var cx = bind_default().bind((styles_module_default()));
function CartToast(param) {
    var className = param.className, merchandiseId = param.merchandiseId, attributeSelectedSize = param.attributeSelectedSize;
    var ref, ref1, ref2;
    var t = (0,lib/* useTranslate */.qM)();
    var cart = (0,useGetCart/* default */.Z)().cart;
    var global = (0,GlobalDataProvider/* useGlobalData */.U)().global;
    var toastTitleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var addedProduct = null;
    var ref3;
    var addedProducts = (ref3 = cart === null || cart === void 0 ? void 0 : (ref = cart.products) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.merchandiseId) === merchandiseId;
    })) !== null && ref3 !== void 0 ? ref3 : null;
    if (addedProducts && (addedProducts === null || addedProducts === void 0 ? void 0 : addedProducts.length) === 1) {
        addedProduct = addedProducts === null || addedProducts === void 0 ? void 0 : addedProducts[0];
    } else {
        var ref4;
        var ref5;
        addedProduct = (ref5 = (ref4 = addedProducts === null || addedProducts === void 0 ? void 0 : addedProducts.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.merchandiseId) === merchandiseId && (item === null || item === void 0 ? void 0 : item.selectedSize) === attributeSelectedSize;
        })) === null || ref4 === void 0 ? void 0 : ref4[0]) !== null && ref5 !== void 0 ? ref5 : null;
    }
    return Boolean(addedProduct) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).CartToast, className),
        children: [
            (global === null || global === void 0 ? void 0 : (ref1 = global.cartPanel) === null || ref1 === void 0 ? void 0 : ref1.toastTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).toastTop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: cx((styles_module_default()).toastTitle, toastTitleStyle),
                    children: global === null || global === void 0 ? void 0 : (ref2 = global.cartPanel) === null || ref2 === void 0 ? void 0 : ref2.toastTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).toastBody,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem/* default */.Z, (0,_object_spread/* default */.Z)({
                    isMini: true,
                    className: (styles_module_default()).cartItem
                }, addedProduct))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).toastBottom,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquaredCta/* default */.Z, {
                        className: (styles_module_default()).cta,
                        theme: colors/* GlobalThemeColors.Black */.b.Black,
                        withBorder: true,
                        withBackground: false,
                        href: constants/* SINGLE_ROUTES.cart.href */.OG.cart.href,
                        children: [
                            t(dictionary/* CTA.CART */.MV.CART),
                            " (",
                            cart === null || cart === void 0 ? void 0 : cart.productsQuantity,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                        className: cx((styles_module_default()).cta),
                        href: cart === null || cart === void 0 ? void 0 : cart.checkoutUrl,
                        theme: colors/* GlobalThemeColors.Black */.b.Black,
                        withBackground: true,
                        withBorder: false,
                        children: t(dictionary/* CTA.CONFIRM_CART */.MV.CONFIRM_CART)
                    })
                ]
            })
        ]
    });
}
CartToast.defaultProps = {};
/* harmony default export */ var Toasts_CartToast = (CartToast);

// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/providers/ToastCenterProvider/index.tsx
var ToastCenterProvider = __webpack_require__(43714);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./src/hooks/useINPTrick/index.ts
var useINPTrick = __webpack_require__(20462);
// EXTERNAL MODULE: ./src/hooks/useLang/index.ts
var useLang = __webpack_require__(7078);
// EXTERNAL MODULE: ./src/hooks/useTextColorFromTheme/index.ts
var useTextColorFromTheme = __webpack_require__(27216);
// EXTERNAL MODULE: ./src/utils/attributes.ts
var utils_attributes = __webpack_require__(44335);
// EXTERNAL MODULE: ./src/components/Abstracts/AddToCartButton/styles.module.scss
var AddToCartButton_styles_module = __webpack_require__(38080);
var AddToCartButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddToCartButton_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/AddToCartButton/index.tsx






















var AddToCartButton_cx = bind_default().bind((AddToCartButton_styles_module_default()));
function AddToCartButton(param) {
    var className = param.className, cartItems = param.cartItems, CtaProps = param.CtaProps, disabled = param.disabled, isOutOfStock = param.isOutOfStock, isPreOrder = param.isPreOrder, onClick = param.onClick, onAdded = param.onAdded, theme = param.theme, inline = param.inline, triggerAddToCart = param.triggerAddToCart, children = param.children, spinnerClassName = param.spinnerClassName;
    var ref = (0,useTextColorFromTheme/* default */.Z)(), color = ref.textColor;
    var addAlert = (0,ToastCenterProvider/* useToastProvider */.Y$)().addAlert;
    var componentColor = theme !== null && theme !== void 0 ? theme : color;
    var ref1 = (0,useINPTrick/* useINPTrick */.z)(), hasInteracted = ref1.hasInteracted, onInteract = ref1.onInteract;
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var t = (0,lib/* useTranslate */.qM)();
    var lang = (0,useLang/* default */.Z)();
    var ref2 = (0,useAddCartLines/* useAddCartLines */.L)({
        onSuccess: function(_, variables) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5;
            var attributeSelectedSize = (ref5 = (ref2 = variables === null || variables === void 0 ? void 0 : (ref = variables[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.key) === constants/* SHOPIFY_ATTRIBUTES.selectedSize */.n1.selectedSize;
            })) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref5 !== void 0 ? ref5 : null;
            // Selected size
            onAdded === null || onAdded === void 0 ? void 0 : onAdded();
            addAlert({
                uid: "add-to-cart-".concat(variables === null || variables === void 0 ? void 0 : (ref3 = variables[0]) === null || ref3 === void 0 ? void 0 : ref3.merchandiseId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toasts_CartToast, {
                    merchandiseId: variables === null || variables === void 0 ? void 0 : (ref4 = variables[0]) === null || ref4 === void 0 ? void 0 : ref4.merchandiseId,
                    attributeSelectedSize: attributeSelectedSize
                })
            });
        },
        onError: function() {
            return triggerAlert();
        }
    }), addItems = ref2.mutate, isLoading = ref2.isLoading;
    var cart = (0,useGetCart/* default */.Z)().cart;
    var ref3 = (0,useUpdateCartAttributes/* useUpdateCartAttributes */.y)({
        onSuccess: function() {
            return addToCart();
        },
        onError: function() {
            return triggerAlert();
        }
    }), updateCartCustomAttribute = ref3.mutate;
    var onAddToCartClick = function() {
        if (cartItems.length === 0) return;
        var attributes = (cart !== null && cart !== void 0 ? cart : {}).attributes;
        var processedAttributes = (0,utils_attributes/* objectAsAttributes */.I)(attributes);
        return updateCartCustomAttribute({
            cartId: cart === null || cart === void 0 ? void 0 : cart.cartId,
            attributes: (0,_to_consumable_array/* default */.Z)(processedAttributes).concat([
                {
                    key: constants/* SHOPIFY_CART_ATTRIBUTES.cartLang */.VO.cartLang,
                    value: lang
                }, 
            ])
        });
    };
    var addToCart = function() {
        if (!isLoading) {
            if (onClick) onClick();
            addItems(cartItems);
        }
    };
    (0,react.useEffect)(function() {
        if (triggerAddToCart) onAddToCartClick();
    }, [
        triggerAddToCart
    ]);
    return inline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CtaProps), {
        className: AddToCartButton_cx(className, (AddToCartButton_styles_module_default()).addToCart, hasInteracted && (AddToCartButton_styles_module_default()).hasInteracted),
        theme: componentColor,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        onClick: function() {
            return onInteract(onAddToCartClick);
        },
        isLoading: isLoading,
        disabled: isOutOfStock || disabled,
        withBackground: true,
        children: isOutOfStock ? t(dictionary/* CTA.OUT_OF_STOCK */.MV.OUT_OF_STOCK) : isPreOrder ? t(dictionary/* CTA.PRE_ORDER */.MV.PRE_ORDER) : t(dictionary/* CTA.ADD_TO_CART */.MV.ADD_TO_CART)
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CtaProps), {
        className: AddToCartButton_cx(className, (AddToCartButton_styles_module_default()).addToCart, hasInteracted && (AddToCartButton_styles_module_default()).hasInteracted),
        theme: componentColor,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        onClick: function() {
            onInteract(onAddToCartClick);
        },
        isLoading: isLoading,
        disabled: isOutOfStock || disabled,
        spinnerClassName: spinnerClassName,
        children: children ? children : isOutOfStock ? t(dictionary/* CTA.OUT_OF_STOCK */.MV.OUT_OF_STOCK) : isPreOrder ? t(dictionary/* CTA.PRE_ORDER */.MV.PRE_ORDER) : t(dictionary/* CTA.ADD_TO_CART */.MV.ADD_TO_CART)
    }));
}
AddToCartButton.defaultProps = {
    isOutOfStock: false
};
/* harmony default export */ var Abstracts_AddToCartButton = (AddToCartButton);


/***/ }),

/***/ 9222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ asText; }
});

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/as-text.ts
var convertNodeToText = function(richTextField) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    var result = "";
    for(var i = 0; i < (richTextField === null || richTextField === void 0 ? void 0 : richTextField.length); i++){
        var ref;
        var ref1;
        var richTextContents = (ref1 = (ref = richTextField[i]) === null || ref === void 0 ? void 0 : ref.content) !== null && ref1 !== void 0 ? ref1 : null;
        if (richTextContents) {
            for(var j = 0, k = richTextContents === null || richTextContents === void 0 ? void 0 : richTextContents.length; j < k; j++){
                var currentRichTextContent = richTextContents[j];
                if ("text" in currentRichTextContent) {
                    result += (result ? separator : "") + (currentRichTextContent === null || currentRichTextContent === void 0 ? void 0 : currentRichTextContent.text);
                }
            }
        }
    }
    return result;
};

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/index.ts

var asText = function(structuredText) {
    if (Object.prototype.toString.call(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content) !== "[object Array]") {
        // console.warn(
        //   `Rich text argument should be an Array. Received ${typeof structuredText}`,
        // )
        return null;
    }
    return convertNodeToText(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content);
};



/***/ }),

/***/ 95886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13200);






function WrapperWithLink(_param) {
    var className = _param.className, children = _param.children, href = _param.href, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, rest), {
            className: className,
            children: children
        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: children
        })
    });
}
WrapperWithLink.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (WrapperWithLink);


/***/ }),

/***/ 26880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CartItem; }
/* harmony export */ });
/* unused harmony export ProductImage */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14408);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36575);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96660);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(55522);
/* harmony import */ var _components_Abstracts_WrapperWithLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95886);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51025);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85499);
/* harmony import */ var _components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35007);
/* harmony import */ var _providers_PanelProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92397);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60118);
/* harmony import */ var _providers_TrackerProvider__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34299);
/* harmony import */ var _hooks_useAlerts__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(827);
/* harmony import */ var _hooks_useINPTrick__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20462);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(93641);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_18__);






















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default()));
var IMAGE_SIZES = [
    {
        breakpoint: "lg",
        ratio: 10 / 60
    },
    {
        ratio: 8 / 30
    }
];
function ProductImage(param) {
    var className = param.className, src = param.src;
    return src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            layout: "fill",
            objectFit: "cover",
            objectPosition: "bottom",
            ratio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().ratio),
            sizesFromBreakpoints: IMAGE_SIZES,
            src: src,
            asPlaceholder: true
        })
    });
}
function ProductRemoveCta(param) {
    var onDelete = param.onDelete;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ctaStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_6__/* .GlobalTextStyling.UpperCase */ .l.UpperCase
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().removeCta), ctaStyle),
        onClick: onDelete,
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Cta10GroteskRegular */ .C.Cta10GroteskRegular,
        theme: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black,
        children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CTA.REMOVE_FROM_CART */ .MV.REMOVE_FROM_CART)
    });
}
function ProductTopRow(param) {
    var title = param.title, href = param.href, price = param.price, designer = param.designer, quantity = param.quantity, removeCurrent = param.removeCurrent;
    var productPriceStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Label12Grotesk */ .C.Label12Grotesk
    });
    var productLabelStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Label12Grotesk */ .C.Label12Grotesk
    });
    var designerStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Text12_20SangBleu */ .C.Text12_20SangBleu,
        color: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productTopRow)),
        children: [
            price && quantity && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().price), productPriceStyle),
                children: [
                    quantity,
                    "x ",
                    price
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Abstracts_WrapperWithLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                href: href,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productLink),
                onClick: removeCurrent,
                children: [
                    designer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().itemDesigner), designerStyle),
                        children: designer
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().itemTitle), productLabelStyle),
                        children: title
                    })
                ]
            })
        ]
    });
}
function ProductBottomRow(_param) {
    var handleDelete = _param.handleDelete, isRemoving = _param.isRemoving, isMini = _param.isMini, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, [
        "handleDelete",
        "isRemoving",
        "isMini"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productBottomRow)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductInfo, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productInfos)
            }, rest)),
            !isRemoving && !isMini && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductRemoveCta, {
                onDelete: handleDelete
            })
        ]
    });
}
function ProductInfo(param) {
    var className = param.className, selectedSize = param.selectedSize, isAdjusting = param.isAdjusting, isPreOrder = param.isPreOrder, isUniqueSize = param.isUniqueSize;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var labelStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Label10Grotesk */ .C.Label10Grotesk,
        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_6__/* .GlobalTextStyling.UpperCase */ .l.UpperCase
    });
    var sizeStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Text12GroteskRegular */ .C.Text12GroteskRegular
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productInfo)),
        children: [
            isPreOrder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().label), labelStyle),
                children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CART.PRE_ORDER */ .$L.PRE_ORDER)
            }),
            isUniqueSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().label), labelStyle),
                children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CART.UNIQUE_SIZE */ .$L.UNIQUE_SIZE)
            }),
            isAdjusting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().label), labelStyle),
                children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CART.ADJUSTED_SIZE */ .$L.ADJUSTED_SIZE)
            }),
            selectedSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().label), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().sizeLabel), labelStyle),
                children: [
                    t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CART.NORMAL_SIZE */ .$L.NORMAL_SIZE),
                    "\xa0:",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().selectedSize), sizeStyle),
                        children: selectedSize
                    })
                ]
            })
        ]
    });
}
function ProductDeleteConfirmation(param) {
    var onConfirm = param.onConfirm, onCancel = param.onCancel;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Label10Grotesk */ .C.Label10Grotesk
    });
    var ref = (0,_hooks_useINPTrick__WEBPACK_IMPORTED_MODULE_16__/* .useINPTrick */ .z)(), hasInteracted = ref.hasInteracted, onInteract = ref.onInteract;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().deleteConfirmation),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().deleteTitle), titleStyle),
                children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CART.REMOVE_TITLE */ .$L.REMOVE_TITLE)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().deleteButtons),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().cta), hasInteracted && (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().hasInteracted)),
                        theme: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black,
                        withBorder: true,
                        withBackground: false,
                        onClick: function() {
                            return onInteract(onCancel);
                        },
                        children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CTA.CANCEL */ .MV.CANCEL)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().cta), hasInteracted && (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().hasInteracted)),
                        theme: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black,
                        onClick: function() {
                            return onInteract(onConfirm);
                        },
                        withBackground: true,
                        withBorder: false,
                        children: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_17__/* .CTA.REMOVE */ .MV.REMOVE)
                    })
                ]
            })
        ]
    });
}
function CartItem(param) {
    var className = param.className, title = param.title, designer = param.designer, imageSrc = param.imageSrc, size = param.size, price = param.price, reference = param.reference, quantity = param.quantity, isAdjusting = param.isAdjusting, isPreOrder = param.isPreOrder, isUniqueSize = param.isUniqueSize, selectedSize = param.selectedSize, attributes = param.attributes, priceAmount = param.priceAmount, href = param.href, id = param.id, isMini = param.isMini, isMutating = param.isMutating, setIsMutating = param.setIsMutating;
    var removeCurrent = (0,_providers_PanelProvider__WEBPACK_IMPORTED_MODULE_12__/* .usePanel */ .uR)().removeCurrent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isRemoving = ref[0], setIsRemoving = ref[1];
    var referenceStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Text12GroteskRegular */ .C.Text12GroteskRegular
    });
    var triggerAlert = (0,_hooks_useAlerts__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var tracker = (0,_providers_TrackerProvider__WEBPACK_IMPORTED_MODULE_14__/* .useTracker */ .Q4)();
    var triggerEvent = function(event) {
        var ref, ref1;
        tracker.emit(event, {
            item: (ref1 = JSON.parse((ref = attributes === null || attributes === void 0 ? void 0 : attributes._trackingData) !== null && ref !== void 0 ? ref : "")) !== null && ref1 !== void 0 ? ref1 : {}
        });
    };
    var ref1 = (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useUpdateCartLines */ .C)({
        onError: function() {
            setIsMutating(false);
            triggerAlert();
        },
        onSuccess: function() {
            triggerEvent(_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .TRACKING_EVENTS.PRODUCT_REMOVE_FROM_CART */ .Iy.PRODUCT_REMOVE_FROM_CART);
            setIsMutating(false);
        }
    }), onUpdateMutation = ref1.mutate;
    var onDelete = function() {
        if (id) {
            setIsMutating(true);
            onUpdateMutation([
                {
                    id: id,
                    quantity: 0
                }, 
            ]);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().CartItem), className, {
            isMutating: isMutating,
            isMini: isMini
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productInfos),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Abstracts_WrapperWithLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().imageWrapper)),
                    href: href,
                    onClick: removeCurrent,
                    children: [
                        imageSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImage, {
                            src: imageSrc
                        }),
                        reference && !isMini && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().reference), referenceStyle),
                            children: reference
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_18___default().productInfosRows),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductTopRow, {
                            title: title,
                            designer: designer,
                            href: href,
                            price: price,
                            quantity: isMini ? 1 : quantity,
                            removeCurrent: removeCurrent
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBottomRow, {
                            isMini: isMini,
                            isAdjusting: isAdjusting,
                            isPreOrder: isPreOrder,
                            isUniqueSize: isUniqueSize,
                            selectedSize: selectedSize,
                            handleDelete: function() {
                                setIsRemoving(true);
                            },
                            isRemoving: isRemoving
                        }),
                        isRemoving && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductDeleteConfirmation, {
                            onConfirm: onDelete,
                            onCancel: function() {
                                setIsRemoving(false);
                            }
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 97839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51526);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57891);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51025);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69235);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
function ImageHover(_param) {
    var className = _param.className, isHovering = _param.isHovering, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "isHovering"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isImageHoverLoaded = ref[0], setIsImageHoverLoaded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
        children: isHovering && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_7__.m.div, {
            className: cx(className),
            initial: {
                opacity: 0
            },
            animate: isImageHoverLoaded ? {
                opacity: 1,
                transition: {
                    duration: 0.25
                }
            } : {},
            exit: {
                opacity: 0,
                transition: {
                    duration: 0.25
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                onLoadingComplete: function() {
                    setIsImageHoverLoaded(true);
                }
            }, rest))
        })
    });
}
ImageHover.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (ImageHover);


/***/ }),

/***/ 23816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsHover/index.js
var useIsHover = __webpack_require__(61356);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useDeviceType/index.js
var useDeviceType = __webpack_require__(9011);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/ImageHover/index.tsx
var ImageHover = __webpack_require__(97839);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(51526);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 19 modules
var motion_minimal = __webpack_require__(57891);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./src/lib/process-cart-items.ts
var process_cart_items = __webpack_require__(51300);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(60119);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
;// CONCATENATED MODULE: ./src/components/Abstracts/ErrorBoundary/index.tsx





var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary() {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        // Example "componentStack":
        //   in ComponentThatThrows (created by App)
        //   in ErrorBoundary (created by App)
        //   in div (created by App)
        //   in App
        console.error(error, errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack);
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            var ref;
            if ((ref = this.props) === null || ref === void 0 ? void 0 : ref.fallback) {
                return this.props.fallback;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);


// EXTERNAL MODULE: ./src/components/Popins/MarketsPopin/index.tsx + 3 modules
var MarketsPopin = __webpack_require__(40079);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Abstracts/AddToCartButton/index.tsx + 1 modules
var AddToCartButton = __webpack_require__(28542);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/OutOfStockButton/index.tsx




function OutOfStockButton(param) {
    var className = param.className, outOfStockCTAText = param.outOfStockCTAText, link = param.link;
    var t = (0,lib/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
        className: className,
        withBackground: true,
        withHover: false,
        onClick: function() {
            return (link === null || link === void 0 ? void 0 : link.href) && router.push(link === null || link === void 0 ? void 0 : link.href);
        },
        children: t(outOfStockCTAText)
    });
}

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/PreOrderButton/index.tsx





function PreOrderButton(param) {
    var className = param.className, link = param.link;
    var t = (0,lib/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
        className: className,
        withBackground: true,
        withHover: false,
        onClick: function() {
            return (link === null || link === void 0 ? void 0 : link.href) && router.push(link === null || link === void 0 ? void 0 : link.href);
        },
        children: t(dictionary/* CTA.PRE_ORDER */.MV.PRE_ORDER)
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/styles.module.scss
var styles_module = __webpack_require__(69428);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/utils/is-size-or-default-variant-name.ts
var is_size_or_default_variant_name = __webpack_require__(64349);
// EXTERNAL MODULE: ./src/utils/variant-helpers.ts
var variant_helpers = __webpack_require__(83771);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/VariantsCta/index.tsx













var cx = bind_default().bind((styles_module_default()));
function VariantsCta(param) {
    var variants = param.variants, defaultVariant = param.defaultVariant, onAddToCart = param.onAddToCart, name = param.name, designer = param.designer, image = param.image, lang = param.lang, isPreOrder = param.isPreOrder, trackingData = param.trackingData;
    var ref, ref1;
    var isAdjusting = variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
        return variant === null || variant === void 0 ? void 0 : variant.isVariantAdjusting;
    });
    var ctaStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular
    });
    var ref2;
    var options = (ref2 = variants === null || variants === void 0 ? void 0 : variants.reduce(function(acc, variant) {
        var ref;
        variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptions) === null || ref === void 0 ? void 0 : ref.forEach(function(option) {
            var ref, ref1;
            if (!acc[option.name]) {
                acc[option.name] = [];
            }
            var ref2;
            var selectedOptions = (0,_to_consumable_array/* default */.Z)((ref2 = defaultVariant === null || defaultVariant === void 0 ? void 0 : (ref = defaultVariant.selectedOptions) === null || ref === void 0 ? void 0 : (ref1 = ref.filter) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(selectedOption) {
                return selectedOption.name !== option.name;
            })) !== null && ref2 !== void 0 ? ref2 : []).concat([
                option, 
            ]);
            var _$variant = (0,variant_helpers/* getVariantFromSelectedOptions */._)(selectedOptions, variants);
            if (_$variant && !acc[option.name].find(function(v) {
                return v.id === _$variant.id && (isAdjusting ? v.title === _$variant.title : true);
            })) {
                acc[option.name].push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$variant), {
                    title: option.value
                }));
            }
        });
        return acc;
    }, {})) !== null && ref2 !== void 0 ? ref2 : {};
    var variantKeys = Object.keys(options);
    var variantsToDisplay = function() {
        var ref;
        return (variants === null || variants === void 0 ? void 0 : variants.length) >= 1 ? (ref = variantKeys === null || variantKeys === void 0 ? void 0 : variantKeys.map(function(key) {
            var isSize = (0,is_size_or_default_variant_name/* isSizeOrDefaultVariantName */.j)(key);
            var selectVariants = options[key];
            return isSize ? selectVariants === null || selectVariants === void 0 ? void 0 : selectVariants.map(function(variant) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                    title: "".concat(variant === null || variant === void 0 ? void 0 : variant.title).concat(isSize && (variant === null || variant === void 0 ? void 0 : variant.isVariantAdjusting) ? "*" : "")
                });
            }) : null;
        })) === null || ref === void 0 ? void 0 : ref.filter(Boolean) : [];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).variantsCta,
        children: (ref1 = (ref = variantsToDisplay()) === null || ref === void 0 ? void 0 : ref.flat()) === null || ref1 === void 0 ? void 0 : ref1.map(function(variant, i) {
            var ref;
            if (!variant) return null;
            var ref1, ref2, ref3, ref4, ref5;
            var cartItems = (0,process_cart_items/* processCartItems */.l)({
                merchandiseId: variant === null || variant === void 0 ? void 0 : variant.id,
                quantity: 1,
                attributes: {
                    isUniqueSize: false,
                    selectedSize: (ref1 = variant === null || variant === void 0 ? void 0 : variant.title) !== null && ref1 !== void 0 ? ref1 : null,
                    image: (ref2 = image === null || image === void 0 ? void 0 : (ref = image.data) === null || ref === void 0 ? void 0 : ref.src) !== null && ref2 !== void 0 ? ref2 : null,
                    name: name,
                    designer: designer,
                    reference: (ref3 = variant === null || variant === void 0 ? void 0 : variant.sku) !== null && ref3 !== void 0 ? ref3 : null,
                    lang: lang,
                    isAdjusting: (ref4 = variant === null || variant === void 0 ? void 0 : variant.isVariantAdjusting) !== null && ref4 !== void 0 ? ref4 : null,
                    trackingData: (ref5 = JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingData), {
                        sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                        variant: variant === null || variant === void 0 ? void 0 : variant.title
                    }), function(key, value) {
                        var ref;
                        return typeof value === "string" ? (ref = encodeURI(value)) === null || ref === void 0 ? void 0 : ref.replace(/'/g, "`") : value;
                    })) !== null && ref5 !== void 0 ? ref5 : ""
                }
            });
            var preOrder = isPreOrder && (variant === null || variant === void 0 ? void 0 : variant.currentlyNotInStock);
            return !preOrder && (variant === null || variant === void 0 ? void 0 : variant.availableForSale) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
                theme: colors/* GlobalThemeColors.White */.b.White,
                CtaProps: {
                    withBackground: true,
                    withHover: true,
                    spinnerClassName: (styles_module_default()).spinner
                },
                onClick: onAddToCart,
                cartItems: cartItems,
                className: cx((styles_module_default()).variantQuickBuy, ctaStyle, {
                    preOrder: preOrder
                }),
                children: variant === null || variant === void 0 ? void 0 : variant.title
            }, "".concat(variant === null || variant === void 0 ? void 0 : variant.id, "-").concat(i, "-").concat(variant === null || variant === void 0 ? void 0 : variant.title)) : null;
        })
    });
}

;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/Content/index.tsx








var Content_cx = classnames_default().bind((styles_module_default()));
function ProductCardQuickBuyContent(param) {
    var isAvailableForSale = param.isAvailableForSale, outOfStockCTAText = param.outOfStockCTAText, shouldEnablePreOrder = param.shouldEnablePreOrder, isUniqueVariant = param.isUniqueVariant, onAddToCart = param.onAddToCart, lang = param.lang, cartItems = param.cartItems, isPreOrder = param.isPreOrder, designer = param.designer, image = param.image, name = param.name, trackingData = param.trackingData, defaultVariant = param.defaultVariant, variantsAvailableToSell = param.variantsAvailableToSell, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isAvailableForSale ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockButton, {
            className: Content_cx((styles_module_default()).button, (styles_module_default()).disabled),
            link: link,
            outOfStockCTAText: outOfStockCTAText
        }) : shouldEnablePreOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreOrderButton, {
            className: Content_cx((styles_module_default()).button, (styles_module_default()).disabled),
            link: link
        }) : isUniqueVariant ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
            theme: colors/* GlobalThemeColors.Black */.b.Black,
            CtaProps: {
                withBackground: true,
                withHover: true,
                withBorder: false
            },
            className: Content_cx((styles_module_default()).button, (styles_module_default()).addToCart),
            onClick: onAddToCart,
            cartItems: cartItems
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantsCta, {
            variants: variantsAvailableToSell,
            defaultVariant: defaultVariant,
            onAddToCart: onAddToCart,
            lang: lang,
            designer: designer,
            image: image,
            name: name,
            isPreOrder: isPreOrder,
            trackingData: trackingData
        })
    });
}

// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/Icon/index.tsx



function Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PlusIcon */.pO, {
        className: (styles_module_default()).icon
    });
}

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Spinner/index.js
var Spinner = __webpack_require__(38137);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/Loader/index.tsx



function Loader() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).loaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
            className: (styles_module_default()).spinner,
            color: "#2c2c2c"
        })
    });
}

// EXTERNAL MODULE: ./src/providers/PopInProvider/index.tsx
var PopInProvider = __webpack_require__(18286);
// EXTERNAL MODULE: ./src/providers/TrackerProvider/index.tsx + 1 modules
var TrackerProvider = __webpack_require__(34299);
// EXTERNAL MODULE: ./src/hooks/useGetProduct/index.ts
var useGetProduct = __webpack_require__(69992);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/data/serialize-shopify-product-data.ts + 4 modules
var serialize_shopify_product_data = __webpack_require__(39294);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/ProductCardQuickBuy/index.tsx





















var ProductCardQuickBuy_cx = bind_default().bind((styles_module_default()));
function ProductCardQuickBuy(param) {
    var className = param.className, unprocessedVariants = param.variants, name = param.name, image = param.image, designer = param.designer, isPreOrder = param.isPreOrder, trackingData = param.trackingData, display = param.display, shopifyId = param.shopifyId, isAdjusting = param.isAdjusting, adjustableOffset = param.adjustableOffset, hasStockAlert = param.hasStockAlert, isSpecialOrder = param.isSpecialOrder, link = param.link;
    var ref, ref1, ref2, ref3, ref4;
    var locale = (0,useLocale/* default */.Z)();
    var ref5 = (0,useGetProduct/* useGetProduct */.K)({
        id: shopifyId,
        includeQuantityAvailable: true,
        includeTags: false,
        locale: locale
    }), data = ref5.data, isLoading = ref5.isLoading;
    var ref6 = (0,react.useState)(display), displayQuickBuy = ref6[0], setDisplayQuickBuy = ref6[1];
    var tracker = (0,TrackerProvider/* useTracker */.Q4)();
    var lang = (0,MarketsPopin/* getLangFromLocaleString */.X)(locale);
    var removeCurrent = (0,PopInProvider/* usePopIn */.wG)().removeCurrent;
    var variants = (0,react.useMemo)(function() {
        if (!data) return unprocessedVariants;
        var productData = (0,serialize_shopify_product_data/* serializeShopifyProductData */.u)({
            isAdjustable: isAdjusting,
            adjustableOffsetValue: adjustableOffset,
            productVariants: data === null || data === void 0 ? void 0 : data.variants,
            productImages: [],
            shopifyProductId: shopifyId,
            media: null,
            locale: locale
        });
        return productData === null || productData === void 0 ? void 0 : productData.variants;
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        setDisplayQuickBuy(display);
    }, [
        display
    ]);
    var variantsAvailableToSell = variants === null || variants === void 0 ? void 0 : variants.filter(function(variant) {
        return (variant === null || variant === void 0 ? void 0 : variant.availableForSale) || (variant === null || variant === void 0 ? void 0 : variant.currentlyNotInStock) && isPreOrder;
    });
    var isAvailableForSale = (variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : variantsAvailableToSell.length) > 0;
    var isUniqueVariant = (variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : variantsAvailableToSell.length) === 1;
    //Get the cheapest variant
    var defaultVariant = (ref = variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : variantsAvailableToSell.sort(function(a, b) {
        var ref, ref1;
        return ((ref = a.unformattedPrice) === null || ref === void 0 ? void 0 : ref.amount) - ((ref1 = b.unformattedPrice) === null || ref1 === void 0 ? void 0 : ref1.amount);
    })) === null || ref === void 0 ? void 0 : ref[0];
    var triggerEvent = function(event) {
        tracker.emit(event, {
            origin: constants/* OriginType.DETAIL_VIEW */.F.DETAIL_VIEW,
            item: trackingData
        });
    };
    var onAddToCart = function() {
        removeCurrent();
        triggerEvent(constants/* TRACKING_EVENTS.PRODUCT_ADD_TO_CART */.Iy.PRODUCT_ADD_TO_CART);
    };
    var ref7, ref8, ref9, ref10;
    var cartItems = (0,process_cart_items/* processCartItems */.l)({
        merchandiseId: variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : (ref1 = variantsAvailableToSell[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
        quantity: 1,
        attributes: {
            name: name,
            designer: designer,
            reference: (ref7 = variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : (ref2 = variantsAvailableToSell[0]) === null || ref2 === void 0 ? void 0 : ref2.sku) !== null && ref7 !== void 0 ? ref7 : null,
            lang: lang,
            image: (ref8 = image === null || image === void 0 ? void 0 : (ref3 = image.data) === null || ref3 === void 0 ? void 0 : ref3.src) !== null && ref8 !== void 0 ? ref8 : null,
            selectedSize: (ref9 = variantsAvailableToSell === null || variantsAvailableToSell === void 0 ? void 0 : (ref4 = variantsAvailableToSell[0]) === null || ref4 === void 0 ? void 0 : ref4.title) !== null && ref9 !== void 0 ? ref9 : null,
            isUniqueSize: (variants === null || variants === void 0 ? void 0 : variants.length) === 1,
            trackingData: (ref10 = JSON.stringify(trackingData, function(key, value) {
                var ref;
                return typeof value === "string" ? (ref = encodeURI(value)) === null || ref === void 0 ? void 0 : ref.replace(/'/g, "`") : value;
            })) !== null && ref10 !== void 0 ? ref10 : ""
        }
    });
    var enablePreOrder = isPreOrder && !!(variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
        return variant === null || variant === void 0 ? void 0 : variant.currentlyNotInStock;
    }));
    var outOfStockCTAText = getOutOfStockCTAText(hasStockAlert, isSpecialOrder);
    var animationVariants = {
        open: {
            opacity: 1,
            height: "fit-content"
        },
        close: {
            opacity: 0,
            height: 0
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
        children: [
            displayQuickBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                initial: animationVariants.close,
                animate: animationVariants.open,
                exit: animationVariants.close,
                variants: animationVariants,
                transition: {
                    ease: "easeInOut",
                    duration: 0.2
                },
                className: ProductCardQuickBuy_cx(className, (styles_module_default()).quickBuy, {
                    isLoading: isLoading
                }),
                onClick: function(e) {
                    if (!enablePreOrder || isAvailableForSale) {
                        e.preventDefault();
                    }
                },
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardQuickBuyContent, {
                    isAvailableForSale: isAvailableForSale,
                    outOfStockCTAText: outOfStockCTAText,
                    shouldEnablePreOrder: enablePreOrder,
                    isUniqueVariant: isUniqueVariant,
                    onAddToCart: onAddToCart,
                    lang: lang,
                    cartItems: cartItems,
                    isPreOrder: isPreOrder,
                    designer: designer,
                    image: image,
                    name: name,
                    trackingData: trackingData,
                    defaultVariant: defaultVariant,
                    variantsAvailableToSell: variantsAvailableToSell,
                    link: link
                })
            }, "desktopButton-".concat(shopifyId)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProductCardQuickBuy_cx((styles_module_default()).mobileButton, {
                    fullWidth: !isAvailableForSale || enablePreOrder
                }),
                onClick: function(e) {
                    e.preventDefault();
                    if (!displayQuickBuy && !enablePreOrder && isAvailableForSale) {
                        setDisplayQuickBuy(true);
                    }
                },
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {}) : !isAvailableForSale ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockButton, {
                    className: ProductCardQuickBuy_cx((styles_module_default()).button, (styles_module_default()).disabled),
                    link: link,
                    outOfStockCTAText: outOfStockCTAText
                }) : enablePreOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreOrderButton, {
                    className: ProductCardQuickBuy_cx((styles_module_default()).button, (styles_module_default()).disabled),
                    link: link
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
            }, "mobile-".concat(shopifyId))
        ]
    });
}
function getOutOfStockCTAText(hasStockAlert, isSpecialOrder) {
    if (hasStockAlert) {
        return dictionary/* CTA.QUICKBUY_STOCK_ALERT */.MV.QUICKBUY_STOCK_ALERT;
    }
    if (isSpecialOrder) {
        return dictionary/* CTA.QUICKBUY_SPECIAL_ORDER */.MV.QUICKBUY_SPECIAL_ORDER;
    }
    return dictionary/* CTA.OUT_OF_STOCK */.MV.OUT_OF_STOCK;
}
function ProductCardQuickBuyWithErrorBoundary(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardQuickBuy, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/components/UI/ProductCard/types.ts
var types = __webpack_require__(72206);
// EXTERNAL MODULE: ./src/components/UI/ProductCardTags/index.tsx
var ProductCardTags = __webpack_require__(37145);
// EXTERNAL MODULE: ./src/components/UI/ProductSlider/index.tsx + 1 modules
var ProductSlider = __webpack_require__(2029);
// EXTERNAL MODULE: ./src/components/UI/ProductTag/index.tsx
var ProductTag = __webpack_require__(25539);
// EXTERNAL MODULE: ./src/components/UI/WishlistIcon/index.tsx + 3 modules
var WishlistIcon = __webpack_require__(39760);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/styles.module.scss
var ProductCard_styles_module = __webpack_require__(41397);
var ProductCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductCard_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductCard/index.tsx





















var ProductCard_cx = bind_default().bind((ProductCard_styles_module_default()));
var _obj;
var IMAGE_SIZES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* CARD_PRODUCT_LAYOUT.REGULAR */.u.REGULAR, [
    {
        breakpoint: "md",
        ratio: 1 / 3
    },
    {
        ratio: 1
    }, 
]), (0,_define_property/* default */.Z)(_obj, types/* CARD_PRODUCT_LAYOUT.SMALL_GRID */.u.SMALL_GRID, [
    {
        breakpoint: "md",
        ratio: 1 / 6
    },
    {
        ratio: 1
    }, 
]), (0,_define_property/* default */.Z)(_obj, types/* CARD_PRODUCT_LAYOUT.MEDIUM_GRID */.u.MEDIUM_GRID, [
    {
        breakpoint: "md",
        ratio: 2 / 5
    },
    {
        ratio: 1 / 2
    }, 
]), (0,_define_property/* default */.Z)(_obj, types/* CARD_PRODUCT_LAYOUT.BIG_GRID */.u.BIG_GRID, [
    {
        breakpoint: "md",
        ratio: 1 / 3
    },
    {
        ratio: 1
    }, 
]), (0,_define_property/* default */.Z)(_obj, types/* CARD_PRODUCT_LAYOUT.SEARCH_GRID */.u.SEARCH_GRID, [
    {
        breakpoint: "md",
        ratio: 1 / 4
    },
    {
        ratio: 1 / 2
    }, 
]), _obj);
function ProductCard(param) {
    var className = param.className, shopifyId = param.shopifyId, link = param.link, label = param.label, name = param.name, compareAtPrice = param.compareAtPrice, price = param.price, image = param.image, imageHover = param.imageHover, sustainabilityTags = param.sustainabilityTags, productStatusTags = param.productStatusTags, _layout = param.layout, layout = _layout === void 0 ? types/* CARD_PRODUCT_LAYOUT.REGULAR */.u.REGULAR : _layout, trackingData = param.trackingData, priority = param.priority, sliderItemClassName = param.sliderItemClassName, isPreOrder = param.isPreOrder, designer = param.designer, variants = param.variants, isAdjusting = param.isAdjusting, adjustableOffset = param.adjustableOffset, isWishListCard = param.isWishListCard, customTags = param.customTags, hasStockAlert = param.hasStockAlert, isSpecialOrder = param.isSpecialOrder, wishlistDetails = param.wishlistDetails, _displayWishlistIcon = param.displayWishlistIcon, displayWishlistIcon = _displayWishlistIcon === void 0 ? true : _displayWishlistIcon;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), wasHovered = ref3[0], setWasHovered = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useIsHover/* useIsHover */.c)(), 2), isHovered = ref4[0], callbacks = ref4[1];
    var sliderRef = (0,react.useRef)();
    var device = (0,useDeviceType/* useDeviceType */.h)();
    var creatorStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title15SangBleu */.C.Title15SangBleu
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk
    });
    var compareAtStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    var isHovering = device === useDeviceType/* DeviceType.mobile */.Y.mobile ? false : isHovered;
    var wishListCardMobileStyle = isWishListCard ? (ProductCard_styles_module_default()).wishListCardMobile : "";
    (0,react.useEffect)(function() {
        if (isHovered) {
            setWasHovered(true);
        }
    }, [
        isHovered
    ]);
    var ref5, ref6;
    var firstVariantAvailableForSale = (ref6 = (ref5 = variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
        return variant === null || variant === void 0 ? void 0 : variant.availableForSale;
    })) !== null && ref5 !== void 0 ? ref5 : variants === null || variants === void 0 ? void 0 : variants[0]) !== null && ref6 !== void 0 ? ref6 : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link, callbacks), {
        className: ProductCard_cx((ProductCard_styles_module_default()).ProductCard, className),
        children: [
            (productStatusTags || sustainabilityTags) && (wishlistDetails === null || wishlistDetails === void 0 ? void 0 : wishlistDetails.inList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardTags/* default */.Z, {
                productStatusTags: productStatusTags !== null && productStatusTags !== void 0 ? productStatusTags : null,
                sustainabilityTags: sustainabilityTags !== null && sustainabilityTags !== void 0 ? sustainabilityTags : null,
                customTags: customTags !== null && customTags !== void 0 ? customTags : []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ProductCard_cx((ProductCard_styles_module_default()).imageContainer, (ProductCard_styles_module_default()).imageRatio),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCard_styles_module_default()).overlay,
                        children: wishlistDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProductCard_styles_module_default()).wishlistWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ProductCard_styles_module_default()).widthlistDetails,
                                        children: [
                                            displayWishlistIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistIcon/* default */.Z, {
                                                className: ProductCard_cx((ProductCard_styles_module_default()).wishlist, {
                                                    inList: wishlistDetails === null || wishlistDetails === void 0 ? void 0 : wishlistDetails.inList
                                                }),
                                                shopifyId: shopifyId,
                                                variantId: firstVariantAvailableForSale === null || firstVariantAvailableForSale === void 0 ? void 0 : firstVariantAvailableForSale.id,
                                                trackingData: trackingData,
                                                productLink: link,
                                                uuid: wishlistDetails === null || wishlistDetails === void 0 ? void 0 : wishlistDetails.uuid
                                            }, "wishlist-icon-".concat(shopifyId)),
                                            !(wishlistDetails === null || wishlistDetails === void 0 ? void 0 : wishlistDetails.inList) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ProductCard_styles_module_default()).details,
                                                children: wishlistDetails === null || wishlistDetails === void 0 ? void 0 : (ref = wishlistDetails.tags) === null || ref === void 0 ? void 0 : ref.map(function(label) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag/* default */.Z, {
                                                        className: (ProductCard_styles_module_default()).tag,
                                                        borderColor: colors/* GlobalThemeColors.Gray */.b.Gray,
                                                        children: label
                                                    }, "product-detail-".concat(label));
                                                })
                                            })
                                        ]
                                    })
                                }),
                                shopifyId && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardQuickBuyWithErrorBoundary, {
                                    name: name,
                                    image: image,
                                    trackingData: trackingData,
                                    display: isHovering,
                                    shopifyId: shopifyId,
                                    designer: designer,
                                    isPreOrder: isPreOrder,
                                    variants: variants,
                                    isAdjusting: isAdjusting,
                                    adjustableOffset: adjustableOffset,
                                    hasStockAlert: hasStockAlert,
                                    isSpecialOrder: isSpecialOrder,
                                    wasHovered: wasHovered,
                                    link: link
                                }, shopifyId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ProductCard_cx((ProductCard_styles_module_default()).hideOnSmallScreen),
                        children: [
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image === null || image === void 0 ? void 0 : image.data), {
                                className: ProductCard_cx((ProductCard_styles_module_default()).image),
                                draggable: false,
                                sizesFromBreakpoints: IMAGE_SIZES[layout],
                                layout: "fill",
                                objectFit: "cover",
                                asPlaceholder: true,
                                priority: priority,
                                loader: (image === null || image === void 0 ? void 0 : image.loaderType) === types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK ? Image/* imageLoaderStoryblok */.y : null
                            })),
                            imageHover && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageHover/* default */.Z, (0,_object_spread/* default */.Z)({
                                isHovering: isHovering,
                                className: ProductCard_cx((ProductCard_styles_module_default()).hoverImage),
                                sizesFromBreakpoints: IMAGE_SIZES[layout],
                                layout: "fill",
                                objectFit: "cover",
                                draggable: false,
                                loader: imageHover.loaderType === types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK ? Image/* imageLoaderStoryblok */.y : null
                            }, imageHover.data))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductCard_styles_module_default()).hideOnLargeScreen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSlider/* default */.Z, {
                            className: (ProductCard_styles_module_default()).productSlider,
                            controlsClassName: (ProductCard_styles_module_default()).sliderControls,
                            sliderClassName: (ProductCard_styles_module_default()).slider,
                            ref: sliderRef,
                            infinite: false,
                            children: (ref2 = (ref1 = [
                                image,
                                imageHover
                            ]) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                                return item === null || item === void 0 ? void 0 : item.data;
                            })) === null || ref2 === void 0 ? void 0 : ref2.map(function(image, i) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: ProductCard_cx((ProductCard_styles_module_default()).sliderItem, sliderItemClassName, (ProductCard_styles_module_default())[layout], wishListCardMobileStyle),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProductCard_styles_module_default()).imageRatio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                                            className: (ProductCard_styles_module_default()).image,
                                            draggable: false,
                                            sizesFromBreakpoints: IMAGE_SIZES[layout],
                                            layout: "fill",
                                            objectFit: "cover",
                                            asPlaceholder: true,
                                            loader: image.loaderType === types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK ? Image/* imageLoaderStoryblok */.y : null
                                        }, image.data))
                                    })
                                }, "".concat(image === null || image === void 0 ? void 0 : (ref = image.data) === null || ref === void 0 ? void 0 : ref.src, "-").concat(i));
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductCard_styles_module_default()).bottom,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductCard_styles_module_default()).bottomLeft,
                        children: [
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: ProductCard_cx((ProductCard_styles_module_default()).creator, creatorStyle),
                                children: label
                            }),
                            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: ProductCard_cx((ProductCard_styles_module_default()).title, titleStyle),
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: ProductCard_cx((ProductCard_styles_module_default()).price, titleStyle),
                        children: [
                            compareAtPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                className: ProductCard_cx((ProductCard_styles_module_default()).compareAtPrice, compareAtStyle),
                                children: compareAtPrice
                            }),
                            price
                        ]
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var UI_ProductCard = (ProductCard);


/***/ }),

/***/ 72206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ CARD_IMAGE_LOADER; },
/* harmony export */   "u": function() { return /* binding */ CARD_PRODUCT_LAYOUT; }
/* harmony export */ });
var CARD_PRODUCT_LAYOUT = {
    REGULAR: "regular",
    SMALL_GRID: "small_grid",
    MEDIUM_GRID: "medium_grid",
    BIG_GRID: "big_grid",
    SEARCH_GRID: "search_grid"
};
var CARD_IMAGE_LOADER = {
    STORYBLOK: "storyblok",
    SHOPIFY: "shopify"
};


/***/ }),

/***/ 37145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ PRODUCT_STATUSES; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_UI_ProductTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25539);
/* harmony import */ var _hooks_useProductStatusTagsValues__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62231);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30694);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var PRODUCT_STATUSES = {
    isExclusivity: "EXCLUSIVITY",
    isUniquePiece: "UNIQUE_PIECE",
    isNew: "NEW",
    isBackInstock: "BACK_IN_STOCK"
};
function ProductCardTags(param) {
    var className = param.className, productStatusTags = param.productStatusTags, sustainabilityTags = param.sustainabilityTags, customTags = param.customTags;
    var formattedStatusTags = (0,_hooks_useProductStatusTagsValues__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(productStatusTags);
    var hasStatusTags = (formattedStatusTags === null || formattedStatusTags === void 0 ? void 0 : formattedStatusTags.length) > 0 || (customTags === null || customTags === void 0 ? void 0 : customTags.length) > 0;
    var hasSustainabilityTags = (sustainabilityTags === null || sustainabilityTags === void 0 ? void 0 : sustainabilityTags.length) > 0;
    return hasStatusTags || hasSustainabilityTags ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ProductCardTags), className),
        children: [
            hasStatusTags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().statusTags),
                children: [
                    formattedStatusTags === null || formattedStatusTags === void 0 ? void 0 : formattedStatusTags.map(function(value, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_ProductTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tag)),
                            children: value
                        }, "status_tag_".concat(index));
                    }),
                    customTags === null || customTags === void 0 ? void 0 : customTags.map(function(value, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_ProductTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tag)),
                            children: value
                        }, "custom_status_tag_".concat(index));
                    })
                ]
            }),
            hasSustainabilityTags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sustainabilityTags)),
                children: sustainabilityTags === null || sustainabilityTags === void 0 ? void 0 : sustainabilityTags.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_ProductTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tag)),
                        children: tag
                    }, "sustainability_tag_".concat(index));
                })
            })
        ]
    }) : null;
}
ProductCardTags.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardTags);


/***/ }),

/***/ 2029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_ProductSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/hooks/useSliderState/index.js
var useSliderState = __webpack_require__(80581);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/providers/TrackerProvider/index.tsx + 1 modules
var TrackerProvider = __webpack_require__(34299);
// EXTERNAL MODULE: ./src/components/Abstracts/SliderControls/styles.module.scss
var styles_module = __webpack_require__(57801);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/SliderControls/index.tsx






var cx = bind_default().bind((styles_module_default()));
function SliderControls(param) {
    var className = param.className, buttonClassName = param.buttonClassName, length = param.length, hasSmallerControls = param.hasSmallerControls, setSlideIndex = param.setSlideIndex, slideIndex = param.slideIndex, trackingData = param.trackingData, activeClassName = param.activeClassName, trackingDataValue = param.trackingDataValue;
    //@ts-ignore
    var indexes = (0,_to_consumable_array/* default */.Z)(Array(length).keys());
    var tracker = (0,TrackerProvider/* useTracker */.Q4)();
    var onClickIndex = (0,react.useCallback)(function(index) {
        setSlideIndex === null || setSlideIndex === void 0 ? void 0 : setSlideIndex(index);
    }, [
        setSlideIndex,
        tracker,
        trackingData,
        trackingDataValue
    ]);
    return length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).SliderControls, className, {
            hasSmallerControls: hasSmallerControls
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).buttonsWrapper,
            children: indexes === null || indexes === void 0 ? void 0 : indexes.map(function(_, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    onClick: function() {
                        return onClickIndex(index);
                    },
                    className: cx((styles_module_default()).button, buttonClassName, slideIndex === index && activeClassName)
                }, "sliderControl".concat(index));
            })
        })
    }) : null;
}
SliderControls.defaultProps = {
    hasSmallerControls: false,
    trackingData: false,
    trackingDataValue: false
};

// EXTERNAL MODULE: ./src/components/UI/ProductSlider/styles.module.scss
var ProductSlider_styles_module = __webpack_require__(40609);
var ProductSlider_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductSlider_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductSlider/index.tsx











var ProductSlider_cx = bind_default().bind((ProductSlider_styles_module_default()));
function ProductSlider(_param, ref) {
    var className = _param.className, children = _param.children, controlsClassName = _param.controlsClassName, sliderClassName = _param.sliderClassName, _infinite = _param.infinite, infinite = _infinite === void 0 ? true : _infinite, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "controlsClassName",
        "sliderClassName",
        "infinite"
    ]);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,useSliderState/* default */.Z)(), 2), _$ref1 = _$ref[0], slideIndex = _$ref1.slideIndex, prevSlide = _$ref1.prevSlide, nextSlide = _$ref1.nextSlide, setSliderState = _$ref[1];
    var displayPrevArrow = infinite || slideIndex > 0;
    var displayNextArrow = infinite || slideIndex < (children === null || children === void 0 ? void 0 : children.length) - 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductSlider_cx(className, (ProductSlider_styles_module_default()).ProductSlider),
        children: [
            (children === null || children === void 0 ? void 0 : children.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderControls, {
                        className: ProductSlider_cx((ProductSlider_styles_module_default()).sliderControls, controlsClassName),
                        buttonClassName: (ProductSlider_styles_module_default()).sliderButton,
                        activeClassName: ProductSlider_cx({
                            isActive: true
                        }),
                        length: children === null || children === void 0 ? void 0 : children.length,
                        slideIndex: slideIndex
                    }),
                    displayPrevArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: ProductSlider_cx((ProductSlider_styles_module_default()).arrow, (ProductSlider_styles_module_default()).left),
                        onClick: function(e) {
                            e === null || e === void 0 ? void 0 : e.preventDefault();
                            prevSlide();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowLeftIcon */.Y4, {
                            width: 10
                        })
                    }),
                    displayNextArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: ProductSlider_cx((ProductSlider_styles_module_default()).arrow, (ProductSlider_styles_module_default()).right),
                        onClick: function(e) {
                            e === null || e === void 0 ? void 0 : e.preventDefault();
                            nextSlide();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowRightIcon */.LZ, {
                            width: 10
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: ProductSlider_cx((ProductSlider_styles_module_default()).slider, sliderClassName),
                setSliderState: setSliderState,
                snap: true,
                infinite: true,
                customSliderRef: ref
            }, props), {
                children: children
            }))
        ]
    });
}
/* harmony default export */ var UI_ProductSlider = (/*#__PURE__*/(0,react.forwardRef)(ProductSlider));


/***/ }),

/***/ 25539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95348);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66264);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()));
function ProductTag(param) {
    var className = param.className, children = param.children, borderColor = param.borderColor;
    var textStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_4__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Label10_12Grotesk */ .C.Label10_12Grotesk,
        borderColor: borderColor !== null && borderColor !== void 0 ? borderColor : _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ProductTag), className, textStyle),
        children: children
    });
}
ProductTag.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (ProductTag);


/***/ }),

/***/ 39760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_WishlistIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./src/lib/get-single-route-href.ts
var get_single_route_href = __webpack_require__(62972);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/CustomerProvider/index.js + 1 modules
var CustomerProvider = __webpack_require__(15858);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Spinner/index.js
var Spinner = __webpack_require__(38137);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/IconCta/styles.module.scss
var styles_module = __webpack_require__(60039);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/IconCta/index.tsx













var cx = bind_default().bind((styles_module_default()));
var IconCta_Icons = {
    Heart: "heart"
};
var ICONS = (0,_define_property/* default */.Z)({}, IconCta_Icons.Heart, Icons/* HeartIcon */.h_);
function IconCta(param) {
    var className = param.className, iconClassName = param.iconClassName, text = param.text, icon = param.icon, loading = param.loading, disabled = param.disabled, isActive = param.isActive, onClick = param.onClick, ariaLabel = param.ariaLabel, href = param.href;
    var ref;
    var Icon = (ref = ICONS === null || ICONS === void 0 ? void 0 : ICONS[icon]) !== null && ref !== void 0 ? ref : null;
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx(className, (styles_module_default()).IconCta, {
            loading: loading,
            disabled: disabled,
            isActive: isActive
        }),
        "aria-label": ariaLabel,
        onClick: onClick
    }, href && {
        href: href
    }), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
            className: cx((styles_module_default()).spinner)
        }) : Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            className: cx((styles_module_default()).icon, iconClassName)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: textStyle,
            children: text
        })
    }));
}
IconCta.defaultProps = {
    loading: false,
    disabled: false
};
/* harmony default export */ var UI_IconCta = (IconCta);

// EXTERNAL MODULE: ./src/providers/TrackerProvider/index.tsx + 1 modules
var TrackerProvider = __webpack_require__(34299);
// EXTERNAL MODULE: ./src/hooks/useINPTrick/index.ts
var useINPTrick = __webpack_require__(20462);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/data/serialize-wishlist-products.ts + 1 modules
var serialize_wishlist_products = __webpack_require__(76803);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./src/hooks/wishlist/useGetWishlist/index.ts
var useGetWishlist = __webpack_require__(90191);
// EXTERNAL MODULE: ./src/hooks/wishlist/useWishlistCookie/index.ts
var useWishlistCookie = __webpack_require__(91225);
// EXTERNAL MODULE: ./src/lib/handle-api.ts + 1 modules
var handle_api = __webpack_require__(16445);
;// CONCATENATED MODULE: ./src/hooks/wishlist/useAddProductToWishlist/index.ts













//TODO: update any type
function useAddProductToWishlist(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,useWishlistCookie/* useWishlistCookie */._)(), wishlistCookie = ref.wishlistCookie, createWishlistCookie = ref.createWishlistCookie;
    var wishlistQueryKey = (0,useGetWishlist/* useWishlistQueryKey */.O)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var locale = (0,useLocale/* default */.Z)();
    var triggerSuccessAlert = (0,useAlerts/* default */.Z)();
    var triggerErrorAlert = (0,useAlerts/* default */.Z)();
    var customerAccessToken = (0,CustomerProvider/* useCustomerContext */.jt)().customerAccessToken;
    return (0,useMutation/* useMutation */.D)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var _quantity, requestPayload, payload, createWishlistResponse, litsId, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestPayload = {
                            wishlist: wishlistCookie,
                            action: "add",
                            products: [
                                {
                                    epi: params.variantId,
                                    empi: params.productId,
                                    du: "".concat("https://www.whitebirdjewellery.com").concat(params.link.href),
                                    quantity: (_quantity = params.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                                    uuid: params.uuid
                                }
                            ]
                        };
                        if (!!(wishlistCookie === null || wishlistCookie === void 0 ? void 0 : wishlistCookie.lid)) return [
                            3,
                            2
                        ];
                        payload = {
                            regid: wishlistCookie === null || wishlistCookie === void 0 ? void 0 : wishlistCookie.regid,
                            sessionid: wishlistCookie === null || wishlistCookie === void 0 ? void 0 : wishlistCookie.sessionid,
                            lname: "My Wishlist"
                        };
                        return [
                            4,
                            (0,handle_api/* createWishlist */.tO)({
                                accessToken: customerAccessToken,
                                payload: payload
                            })
                        ];
                    case 1:
                        createWishlistResponse = _state.sent();
                        litsId = createWishlistResponse === null || createWishlistResponse === void 0 ? void 0 : createWishlistResponse.lid;
                        createWishlistCookie((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wishlistCookie), {
                            lid: litsId
                        }));
                        if (litsId) {
                            requestPayload.wishlist = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wishlistCookie), {
                                lid: litsId
                            });
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0,handle_api/* updateWishlistProducts */.S3)({
                                accessToken: customerAccessToken,
                                payload: requestPayload
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            2,
                            (0,_object_spread/* default */.Z)({
                                products: response === null || response === void 0 ? void 0 : response.a
                            }, response)
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), {
        // Optimistically update the wishlist
        onMutate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var variantId, productId, uuid, prevResponse, newProduct, _products;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            variantId = param.variantId, productId = param.productId, uuid = param.uuid;
                            return [
                                4,
                                queryClient.cancelQueries(wishlistQueryKey)
                            ];
                        case 1:
                            _state.sent();
                            prevResponse = queryClient.getQueryData(wishlistQueryKey);
                            if (!prevResponse) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0,serialize_wishlist_products/* serializeWishlistProductCard */._)({
                                    locale: locale,
                                    productField: {
                                        epi: variantId,
                                        empi: productId,
                                        cprops: {
                                            uuid: uuid
                                        }
                                    }
                                })
                            ];
                        case 2:
                            newProduct = _state.sent();
                            queryClient.setQueryData(wishlistQueryKey, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevResponse), {
                                products: (0,_to_consumable_array/* default */.Z)((_products = prevResponse.products) !== null && _products !== void 0 ? _products : []).concat([
                                    newProduct
                                ])
                            }));
                            _state.label = 3;
                        case 3:
                            return [
                                2,
                                {
                                    prevResponse: prevResponse
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onSuccess: function(data) {
            var ref, ref1;
            if ((data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.hasError) || (data === null || data === void 0 ? void 0 : data.success) === false) {
                triggerErrorAlert();
                return;
            }
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            triggerSuccessAlert("ADDED_WISHLIST");
        },
        onError: function(_err, _variables, context) {
            // If the mutation fails, use the previous value as a backup
            if (context === null || context === void 0 ? void 0 : context.prevResponse) {
                queryClient.setQueryData(wishlistQueryKey, context.prevResponse);
            }
            triggerErrorAlert();
        },
        onSettled: function() {
            // Invalidate and refetch the wishlist
            queryClient.invalidateQueries([
                wishlistQueryKey[0]
            ], {
                exact: false
            });
        }
    });
}

// EXTERNAL MODULE: ./src/utils/shopify-ids.ts
var shopify_ids = __webpack_require__(54527);
;// CONCATENATED MODULE: ./src/hooks/wishlist/useRemoveProductToWishlist/index.ts











function useRemoveProductToWishlist(param) {
    var onSuccess = param.onSuccess;
    var wishlistCookie = (0,useWishlistCookie/* useWishlistCookie */._)().wishlistCookie;
    var wishlistQueryKey = (0,useGetWishlist/* useWishlistQueryKey */.O)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var customerAccessToken = (0,CustomerProvider/* useCustomerContext */.jt)().customerAccessToken;
    var triggerSuccessAlert = (0,useAlerts/* default */.Z)();
    var triggerErrorAlert = (0,useAlerts/* default */.Z)();
    return (0,useMutation/* useMutation */.D)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var _quantity, requestPayload, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestPayload = {
                            wishlist: wishlistCookie,
                            action: "delete",
                            products: [
                                {
                                    epi: params.variantId,
                                    empi: params.productId,
                                    du: "".concat("https://www.whitebirdjewellery.com").concat(params.link.href),
                                    quantity: (_quantity = params.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                                    uuid: params.uuid
                                }
                            ]
                        };
                        return [
                            4,
                            (0,handle_api/* updateWishlistProducts */.S3)({
                                accessToken: customerAccessToken,
                                payload: requestPayload
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            (0,_object_spread/* default */.Z)({
                                products: response === null || response === void 0 ? void 0 : response.d
                            }, response)
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), {
        // Optimistically update the wishlist
        onMutate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var variantId, prevResponse, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            variantId = param.variantId;
                            return [
                                4,
                                queryClient.cancelQueries(wishlistQueryKey)
                            ];
                        case 1:
                            _state.sent();
                            prevResponse = queryClient.getQueryData(wishlistQueryKey);
                            if (prevResponse) {
                                ;
                                queryClient.setQueryData(wishlistQueryKey, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevResponse), {
                                    products: prevResponse === null || prevResponse === void 0 ? void 0 : (ref = prevResponse.products) === null || ref === void 0 ? void 0 : ref.filter(function(product) {
                                        return (product === null || product === void 0 ? void 0 : product.variantId) !== (0,shopify_ids/* addGIDPrefix */.iJ)("ProductVariant", variantId);
                                    })
                                }));
                            }
                            return [
                                2,
                                {
                                    prevResponse: prevResponse
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onSuccess: function(data) {
            var ref, ref1;
            if ((data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.hasError) || (data === null || data === void 0 ? void 0 : data.success) === false) {
                triggerErrorAlert();
                return;
            }
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            triggerSuccessAlert("REMOVED_WISHLIST");
        },
        onError: function(_err, _variables, context) {
            // If the mutation fails, use the previous value as a backup
            if (context === null || context === void 0 ? void 0 : context.prevResponse) {
                queryClient.setQueryData(wishlistQueryKey, context.prevResponse);
            }
            triggerErrorAlert();
        },
        onSettled: function() {
            // Invalidate and refetch the wishlist
            queryClient.invalidateQueries([
                wishlistQueryKey[0]
            ], {
                exact: false
            });
        }
    });
}

// EXTERNAL MODULE: ./src/components/UI/WishlistIcon/styles.module.scss
var WishlistIcon_styles_module = __webpack_require__(16417);
var WishlistIcon_styles_module_default = /*#__PURE__*/__webpack_require__.n(WishlistIcon_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/WishlistIcon/index.tsx

















var WishlistIcon_cx = bind_default().bind((WishlistIcon_styles_module_default()));
function WishlistIcon(param) {
    var className = param.className, shopifyId = param.shopifyId, variantId = param.variantId, trackingData = param.trackingData, productLink = param.productLink, uuid = param.uuid;
    var ref;
    var locale = (0,useLocale/* default */.Z)();
    var customerAccessToken = (0,CustomerProvider/* useCustomerContext */.jt)().customerAccessToken;
    var ref1 = (0,react.useTransition)(), isPending = ref1[0], startTransition = ref1[1];
    var data = (0,useGetWishlist/* useGetWishList */.z)().data;
    var ref2 = useAddProductToWishlist({}), addProduct = ref2.mutate, isAdding = ref2.isLoading;
    var ref3 = useRemoveProductToWishlist({}), removeProduct = ref3.mutate, isRemoveProductLoading = ref3.isLoading;
    var tracker = (0,TrackerProvider/* useTracker */.Q4)();
    var router = (0,next_router.useRouter)();
    var ref4 = (0,useINPTrick/* useINPTrick */.z)(), hasInteracted = ref4.hasInteracted, onInteract = ref4.onInteract;
    var referenceVariantId = (0,shopify_ids/* getReferenceIdFromAdminId */.aF)(variantId);
    var referenceProductId = (0,shopify_ids/* getReferenceIdFromAdminId */.aF)(shopifyId);
    var isInWishlist = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.some(function(item) {
        return (item === null || item === void 0 ? void 0 : item.variantId) === variantId;
    });
    var triggerEvent = function(event) {
        tracker.emit(event, {
            origin: constants/* OriginType.DETAIL_VIEW */.F.DETAIL_VIEW,
            item: trackingData
        });
    };
    var handleWishlistAction = function() {
        if (isInWishlist) {
            removeProduct({
                productId: referenceProductId,
                variantId: referenceVariantId,
                link: productLink,
                uuid: uuid
            });
        } else {
            triggerEvent(constants/* TRACKING_EVENTS.ADD_TO_WISHLIST */.Iy.ADD_TO_WISHLIST);
            addProduct({
                productId: referenceProductId,
                variantId: referenceVariantId,
                link: productLink,
                uuid: uuid
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_IconCta, {
        className: WishlistIcon_cx(className, (WishlistIcon_styles_module_default()).WishlistIcon, hasInteracted && (WishlistIcon_styles_module_default()).hasInteracted),
        icon: IconCta_Icons.Heart,
        iconClassName: WishlistIcon_cx((WishlistIcon_styles_module_default()).icon, {
            isActive: Boolean(isInWishlist)
        }),
        loading: isAdding || isRemoveProductLoading || isPending,
        ariaLabel: "wish-list-icon",
        onClick: function(e) {
            e.preventDefault();
            startTransition(function() {
                if (!customerAccessToken) {
                    void router.push("".concat((0,get_single_route_href/* default */.Z)(storyblok_types/* STORYBLOK_TYPES.LOGIN */.nI.LOGIN, locale), "?redirectUrl=").concat(router.asPath));
                    return;
                }
                onInteract(handleWishlistAction);
            });
        }
    });
}
WishlistIcon.defaultProps = {};
/* harmony default export */ var UI_WishlistIcon = (WishlistIcon);


/***/ }),

/***/ 63472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ serializeProductCard; }
/* harmony export */ });
/* unused harmony exports fetchProductCardsByHandles, serializeStoryblokCardData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);
/* harmony import */ var _lib_fetch_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98720);
/* harmony import */ var _lib_storyblok__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57450);
/* harmony import */ var _components_UI_ProductCard_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72206);
/* harmony import */ var _data_serialize_product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57276);









function fetchProductCardsByHandles(uids, locale, perPage) {
    return _fetchProductCardsByHandles.apply(this, arguments);
}
function _fetchProductCardsByHandles() {
    _fetchProductCardsByHandles = _async_to_generator(function(uids, locale, perPage) {
        var ref, ref1, ref2, ref3, ref4, products, ref5, ref6;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!STORYBLOK_PUBLIC_RECENTLY_VIEWED_KEY) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            Storyblok.get("cdn/stories", _object_spread({
                                starts_with: "product_page/",
                                by_slugs: uids,
                                resolve_links: "url",
                                resolve_relations: PRODUCT_PAGE,
                                per_page: perPage !== null && perPage !== void 0 ? perPage : 20,
                                cv: pageSbParams.cv
                            }, (ref3 = pageSbParams === null || pageSbParams === void 0 ? void 0 : pageSbParams.instance) !== null && ref3 !== void 0 ? ref3 : {}))
                        ])
                    ];
                case 1:
                    products = (ref4 = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.stories) !== null && ref4 !== void 0 ? ref4 : [];
                    return [
                        4,
                        Promise.all((ref5 = products === null || products === void 0 ? void 0 : products.map(function(product) {
                            return serializeProductCard(product, locale);
                        })) !== null && ref5 !== void 0 ? ref5 : null)
                    ];
                case 2:
                    return [
                        2,
                        (ref6 = _state.sent()) !== null && ref6 !== void 0 ? ref6 : []
                    ];
            }
        });
    });
    return _fetchProductCardsByHandles.apply(this, arguments);
}
function serializeStoryblokCardData(data, locale, withVariants) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var ref18;
    // We now get all media items not only images
    // So we display images from media, but keep a fallback with data?.items for product with old serialization
    var mediaImages = (ref18 = data === null || data === void 0 ? void 0 : (ref = data.mediaItems) === null || ref === void 0 ? void 0 : ref.filter(function(media) {
        return (media === null || media === void 0 ? void 0 : media.type) === _data_serialize_product__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MEDIA_IMAGE */ .WK;
    })) !== null && ref18 !== void 0 ? ref18 : null;
    var ref19;
    var shopifyImages = (ref19 = mediaImages !== null && mediaImages !== void 0 ? mediaImages : data === null || data === void 0 ? void 0 : data.items) !== null && ref19 !== void 0 ? ref19 : null;
    var hasEnoughImages = (shopifyImages === null || shopifyImages === void 0 ? void 0 : shopifyImages.length) > 1;
    var ref20;
    var firstImage = (ref20 = shopifyImages === null || shopifyImages === void 0 ? void 0 : (ref1 = shopifyImages[0]) === null || ref1 === void 0 ? void 0 : ref1.image) !== null && ref20 !== void 0 ? ref20 : null;
    var ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        shopifyId: (ref21 = data === null || data === void 0 ? void 0 : data.shopifyId) !== null && ref21 !== void 0 ? ref21 : null,
        link: (ref22 = data === null || data === void 0 ? void 0 : data.link) !== null && ref22 !== void 0 ? ref22 : null,
        name: (ref23 = data === null || data === void 0 ? void 0 : data.productName) !== null && ref23 !== void 0 ? ref23 : null,
        trackingData: (ref24 = data === null || data === void 0 ? void 0 : data.trackingData) !== null && ref24 !== void 0 ? ref24 : null,
        designer: (ref25 = data === null || data === void 0 ? void 0 : (ref2 = data.productDesigner) === null || ref2 === void 0 ? void 0 : ref2.children) !== null && ref25 !== void 0 ? ref25 : null,
        image: firstImage || (data === null || data === void 0 ? void 0 : data.cardImage) ? {
            loaderType: (data === null || data === void 0 ? void 0 : data.cardImage) ? _components_UI_ProductCard_types__WEBPACK_IMPORTED_MODULE_3__/* .CARD_IMAGE_LOADER.STORYBLOK */ .p.STORYBLOK : _components_UI_ProductCard_types__WEBPACK_IMPORTED_MODULE_3__/* .CARD_IMAGE_LOADER.SHOPIFY */ .p.SHOPIFY,
            data: (data === null || data === void 0 ? void 0 : data.cardImage) ? data === null || data === void 0 ? void 0 : data.cardImage : firstImage !== null && firstImage !== void 0 ? firstImage : null
        } : null,
        imageHover: (data === null || data === void 0 ? void 0 : data.cardImageHover) || (shopifyImages === null || shopifyImages === void 0 ? void 0 : shopifyImages[1]) ? {
            loaderType: (data === null || data === void 0 ? void 0 : data.cardImageHover) ? _components_UI_ProductCard_types__WEBPACK_IMPORTED_MODULE_3__/* .CARD_IMAGE_LOADER.STORYBLOK */ .p.STORYBLOK : _components_UI_ProductCard_types__WEBPACK_IMPORTED_MODULE_3__/* .CARD_IMAGE_LOADER.SHOPIFY */ .p.SHOPIFY,
            data: (data === null || data === void 0 ? void 0 : data.cardImageHover) ? data === null || data === void 0 ? void 0 : data.cardImageHover : hasEnoughImages ? (ref26 = shopifyImages === null || shopifyImages === void 0 ? void 0 : (ref3 = shopifyImages[1]) === null || ref3 === void 0 ? void 0 : ref3.image) !== null && ref26 !== void 0 ? ref26 : null : null
        } : null,
        breathImages: (data === null || data === void 0 ? void 0 : (ref4 = data.items) === null || ref4 === void 0 ? void 0 : ref4[0]) || (data === null || data === void 0 ? void 0 : (ref6 = data.items) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[(data === null || data === void 0 ? void 0 : (ref5 = data.items) === null || ref5 === void 0 ? void 0 : ref5.length) - 1]) === null || ref7 === void 0 ? void 0 : ref7.image) ? [
            (ref27 = data === null || data === void 0 ? void 0 : (ref8 = data.items) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.image) !== null && ref27 !== void 0 ? ref27 : null,
            (ref29 = (ref28 = data === null || data === void 0 ? void 0 : (ref11 = data.items) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[(data === null || data === void 0 ? void 0 : (ref10 = data.items) === null || ref10 === void 0 ? void 0 : ref10.length) - 1]) === null || ref12 === void 0 ? void 0 : ref12.image) !== null && ref28 !== void 0 ? ref28 : data === null || data === void 0 ? void 0 : (ref13 = data.items) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.image) !== null && ref29 !== void 0 ? ref29 : null, 
        ] : [],
        label: (ref30 = data === null || data === void 0 ? void 0 : (ref15 = data.productDesigner) === null || ref15 === void 0 ? void 0 : ref15.children) !== null && ref30 !== void 0 ? ref30 : null,
        compareAtPrice: (ref31 = data === null || data === void 0 ? void 0 : data.compareAtPrice) !== null && ref31 !== void 0 ? ref31 : null,
        price: (ref32 = data === null || data === void 0 ? void 0 : data.price) !== null && ref32 !== void 0 ? ref32 : null,
        unformattedPrice: (ref33 = data === null || data === void 0 ? void 0 : data.unformattedPrice) !== null && ref33 !== void 0 ? ref33 : null,
        sustainabilityTags: (ref34 = data === null || data === void 0 ? void 0 : data.sustainabilityTags) !== null && ref34 !== void 0 ? ref34 : null,
        productStatusTags: (ref35 = data === null || data === void 0 ? void 0 : data.productStatusTags) !== null && ref35 !== void 0 ? ref35 : null,
        customTags: (ref36 = data === null || data === void 0 ? void 0 : data.customTags) !== null && ref36 !== void 0 ? ref36 : []
    }, withVariants && {
        variants: (ref37 = data === null || data === void 0 ? void 0 : data.variants) !== null && ref37 !== void 0 ? ref37 : [],
        variation: (ref38 = data === null || data === void 0 ? void 0 : data.variation) !== null && ref38 !== void 0 ? ref38 : null
    }), {
        isPreOrder: (ref39 = data === null || data === void 0 ? void 0 : data.isPreOrder) !== null && ref39 !== void 0 ? ref39 : null,
        hasStockAlert: (ref40 = data === null || data === void 0 ? void 0 : (ref16 = data.content) === null || ref16 === void 0 ? void 0 : ref16.has_stock_alert) !== null && ref40 !== void 0 ? ref40 : false,
        isSpecialOrder: (ref41 = data === null || data === void 0 ? void 0 : (ref17 = data.content) === null || ref17 === void 0 ? void 0 : ref17.has_special_order_enabled) !== null && ref41 !== void 0 ? ref41 : false,
        variants: (ref42 = data === null || data === void 0 ? void 0 : data.variants) !== null && ref42 !== void 0 ? ref42 : null,
        isAdjusting: (ref43 = data === null || data === void 0 ? void 0 : data.isAdjusting) !== null && ref43 !== void 0 ? ref43 : false,
        adjustableOffset: (ref44 = data === null || data === void 0 ? void 0 : data.adjustableOffset) !== null && ref44 !== void 0 ? ref44 : 0
    });
}
function serializeProductCard(item, locale, withVariants) {
    return _serializeProductCard.apply(this, arguments);
}
function _serializeProductCard() {
    _serializeProductCard = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(item, locale, withVariants) {
        var ref, ref1, serializedProductCardContent, cardData, ref2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_data_serialize_product__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
                            locale: locale,
                            data: item
                        })
                    ];
                case 1:
                    serializedProductCardContent = (ref1 = _state.sent()) !== null && ref1 !== void 0 ? ref1 : null;
                    if (!serializedProductCardContent) {
                        return [
                            2,
                            null
                        ];
                    }
                    cardData = serializeStoryblokCardData(serializedProductCardContent, locale, withVariants);
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cardData), {
                            wishlistDetails: {
                                inList: true,
                                uuid: (ref2 = item === null || item === void 0 ? void 0 : item.uuid) !== null && ref2 !== void 0 ? ref2 : null,
                                variantId: serializedProductCardContent === null || serializedProductCardContent === void 0 ? void 0 : (ref = serializedProductCardContent.defaultVariant) === null || ref === void 0 ? void 0 : ref.id
                            }
                        })
                    ];
            }
        });
    });
    return _serializeProductCard.apply(this, arguments);
}


/***/ }),

/***/ 57276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WK": function() { return /* binding */ PRODUCT_MEDIA_IMAGE; },
  "r7": function() { return /* binding */ PRODUCT_MEDIA_VIDEO; },
  "ZP": function() { return /* binding */ serialize_product_serializeProduct; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/lib/shopify/metafields/index.ts
var metafields = __webpack_require__(88136);
// EXTERNAL MODULE: ./src/lib/shopify/product/product-by-id.ts
var product_by_id = __webpack_require__(73661);
// EXTERNAL MODULE: ./src/hooks/tracking/useTrackProductCardsList/index.ts
var useTrackProductCardsList = __webpack_require__(16211);
// EXTERNAL MODULE: ./src/utils/alternate-url.ts
var alternate_url = __webpack_require__(50146);
;// CONCATENATED MODULE: ./src/data/json-ld/product/serialize-json-ld.ts

function serializeJSONLD(content, shopify, url, name, description) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6, ref7, ref8, ref9;
    return {
        name: name !== null && name !== void 0 ? name : null,
        brand: {
            name: "WHITEbIRD"
        },
        description: description !== null && description !== void 0 ? description : null,
        sku: (ref6 = shopify === null || shopify === void 0 ? void 0 : shopify.shopifyId) !== null && ref6 !== void 0 ? ref6 : null,
        mpn: null,
        image: (ref7 = (ref1 = shopify === null || shopify === void 0 ? void 0 : (ref = shopify.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.image.src;
        })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
            return item;
        })) !== null && ref7 !== void 0 ? ref7 : null,
        offers: {
            price: "".concat((ref8 = shopify === null || shopify === void 0 ? void 0 : (ref2 = shopify.defaultVariant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.unformattedPrice) === null || ref3 === void 0 ? void 0 : ref3.amount) !== null && ref8 !== void 0 ? ref8 : "0"),
            priceCurrency: (ref9 = shopify === null || shopify === void 0 ? void 0 : (ref4 = shopify.defaultVariant) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.unformattedPrice) === null || ref5 === void 0 ? void 0 : ref5.currencyCode) !== null && ref9 !== void 0 ? ref9 : null,
            url: (0,alternate_url/* default */.Z)(url),
            availability: (shopify === null || shopify === void 0 ? void 0 : shopify.isAvailable) ? "InStock" : "OutOfStock"
        }
    };
}

// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./src/lib/shopify/metafields/helpers.ts
var helpers = __webpack_require__(49344);
// EXTERNAL MODULE: ./src/components/Abstracts/Storyblok/index.ts + 1 modules
var Abstracts_Storyblok = __webpack_require__(9222);
// EXTERNAL MODULE: ./src/utils/check-empty-string.ts
var check_empty_string = __webpack_require__(86867);
// EXTERNAL MODULE: ./src/utils/locales.ts
var locales = __webpack_require__(40457);
// EXTERNAL MODULE: ./src/data/storyblok/texts.ts + 1 modules
var texts = __webpack_require__(32725);
;// CONCATENATED MODULE: ./src/data/product-page-data/serialize-fallback-i18n-fields.ts






function serializeFallbackI18nFields(param) {
    var shopifyProduct = param.shopifyProduct, rawStoryblokData = param.rawStoryblokData, locale = param.locale;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var lang = (0,locales/* getLang */.VQ)(locale);
    var productName = null;
    var productDetails = null;
    var productDescription = null;
    if (!shopifyProduct) {
        return null;
    }
    var ref6;
    // Getting the current Storyblok fields values
    var storyblokTitle = (ref6 = (rawStoryblokData === null || rawStoryblokData === void 0 ? void 0 : (ref = rawStoryblokData.content) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? rawStoryblokData === null || rawStoryblokData === void 0 ? void 0 : (ref2 = rawStoryblokData.content) === null || ref2 === void 0 ? void 0 : ref2.name : null) !== null && ref6 !== void 0 ? ref6 : null;
    var ref7;
    var storyblokDetails = (ref7 = (0,check_empty_string/* isRTFilled */.P)(rawStoryblokData === null || rawStoryblokData === void 0 ? void 0 : (ref3 = rawStoryblokData.content) === null || ref3 === void 0 ? void 0 : ref3.product_details_wysiwyg) ? rawStoryblokData === null || rawStoryblokData === void 0 ? void 0 : (ref4 = rawStoryblokData.content) === null || ref4 === void 0 ? void 0 : ref4.product_details_wysiwyg : null) !== null && ref7 !== void 0 ? ref7 : null;
    var ref8;
    var storyblokDescription = (ref8 = rawStoryblokData === null || rawStoryblokData === void 0 ? void 0 : (ref5 = rawStoryblokData.content) === null || ref5 === void 0 ? void 0 : ref5.product_description) !== null && ref8 !== void 0 ? ref8 : null;
    // Data from the Shopify product
    var shopifyTitles = {
        en: (0,helpers/* getMetafieldValue */.y)(constants/* SHOPIFY_METAFIELDS_KEYS.TITLE_EN */.tT.TITLE_EN, shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.metafields),
        fr: shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.title
    };
    var shopifyDetails = {
        en: (0,helpers/* getMetafieldValue */.y)(constants/* SHOPIFY_METAFIELDS_KEYS.DETAILS_EN */.tT.DETAILS_EN, shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.metafields),
        fr: (0,helpers/* getMetafieldValue */.y)(constants/* SHOPIFY_METAFIELDS_KEYS.DETAILS_FR */.tT.DETAILS_FR, shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.metafields)
    };
    var shopifyDescriptions = {
        en: (0,helpers/* getMetafieldValue */.y)(constants/* SHOPIFY_METAFIELDS_KEYS.DESCRIPTION_EN */.tT.DESCRIPTION_EN, shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.metafields),
        fr: shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.description
    };
    // Starting to override the titles and stuff
    if (!storyblokTitle) {
        if (lang === constants/* DEFAULT_LANG */.Hj) {
            var ref9;
            productName = (ref9 = shopifyTitles === null || shopifyTitles === void 0 ? void 0 : shopifyTitles["en"]) !== null && ref9 !== void 0 ? ref9 : shopifyTitles === null || shopifyTitles === void 0 ? void 0 : shopifyTitles["fr"];
        } else {
            productName = shopifyTitles === null || shopifyTitles === void 0 ? void 0 : shopifyTitles["fr"];
        }
    } else {
        productName = storyblokTitle;
    }
    // Now checking and replacing all the fields
    if (!storyblokDetails) {
        if (lang === constants/* DEFAULT_LANG */.Hj) {
            var ref10, ref11;
            var ref12;
            productDetails = (ref12 = (shopifyDetails === null || shopifyDetails === void 0 ? void 0 : shopifyDetails["en"]) ? (0,texts/* asComplexRichText */.SL)({
                items: (ref11 = shopifyDetails === null || shopifyDetails === void 0 ? void 0 : (ref10 = shopifyDetails["en"]) === null || ref10 === void 0 ? void 0 : ref10.split("\n")) === null || ref11 === void 0 ? void 0 : ref11.map(function(splittedText) {
                    return {
                        type: "paragraph",
                        texts: [
                            splittedText
                        ]
                    };
                })
            }) : null) !== null && ref12 !== void 0 ? ref12 : null;
        } else {
            var ref13, ref14;
            var ref15;
            productDetails = (ref15 = (shopifyDetails === null || shopifyDetails === void 0 ? void 0 : shopifyDetails["fr"]) ? (0,texts/* asComplexRichText */.SL)({
                items: (ref14 = shopifyDetails === null || shopifyDetails === void 0 ? void 0 : (ref13 = shopifyDetails["fr"]) === null || ref13 === void 0 ? void 0 : ref13.split("\n")) === null || ref14 === void 0 ? void 0 : ref14.map(function(splittedText) {
                    return {
                        type: "paragraph",
                        texts: [
                            splittedText
                        ]
                    };
                })
            }) : null) !== null && ref15 !== void 0 ? ref15 : null;
        }
    } else {
        productDetails = storyblokDetails;
    }
    var parsedDescription = storyblokDescription ? (0,Abstracts_Storyblok/* asText */.S)((0,texts/* asRichText */.yG)(storyblokDescription)) : null;
    if (!parsedDescription) {
        if (lang === constants/* DEFAULT_LANG */.Hj) {
            var ref16;
            productDescription = (ref16 = shopifyDescriptions === null || shopifyDescriptions === void 0 ? void 0 : shopifyDescriptions["en"]) !== null && ref16 !== void 0 ? ref16 : null;
        } else {
            var ref17;
            productDescription = (ref17 = shopifyDescriptions === null || shopifyDescriptions === void 0 ? void 0 : shopifyDescriptions["fr"]) !== null && ref17 !== void 0 ? ref17 : null;
        }
    } else {
        productDescription = storyblokDescription;
    }
    return {
        productName: productName,
        productDetails: productDetails,
        productDescription: productDescription
    };
}

// EXTERNAL MODULE: ./src/data/serialize-link.ts
var serialize_link = __webpack_require__(29931);
// EXTERNAL MODULE: ./src/lib/fetch-links.ts
var fetch_links = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/lib/storyblok.ts + 3 modules
var storyblok = __webpack_require__(57450);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./node_modules/node-polyglot/index.js
var node_polyglot = __webpack_require__(54078);
var node_polyglot_default = /*#__PURE__*/__webpack_require__.n(node_polyglot);
;// CONCATENATED MODULE: ./src/utils/i18n.ts

/* harmony default export */ var utils_i18n = (new (node_polyglot_default())());

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
;// CONCATENATED MODULE: ./src/data/product-page-data/serialize-product-attribute.ts

function serialize_product_attribute_serializeProductAttribute(data, locale) {
    var ref;
    var ref1;
    var link = (ref1 = serializeLink(data, locale)) !== null && ref1 !== void 0 ? ref1 : null;
    var ref2, ref3, ref4, ref5, ref6;
    return {
        uuid: (ref2 = data === null || data === void 0 ? void 0 : data.uuid) !== null && ref2 !== void 0 ? ref2 : null,
        slug: (ref3 = data === null || data === void 0 ? void 0 : data.slug) !== null && ref3 !== void 0 ? ref3 : null,
        label: (ref5 = (ref4 = data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.name) !== null && ref4 !== void 0 ? ref4 : data === null || data === void 0 ? void 0 : data.name) !== null && ref5 !== void 0 ? ref5 : null,
        storyID: (ref6 = data === null || data === void 0 ? void 0 : data.id) !== null && ref6 !== void 0 ? ref6 : null,
        link: link
    };
}

;// CONCATENATED MODULE: ./src/data/serialize-date.ts

var OPTS = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
};
function serialize_date_serializeDate(date, locale) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : OPTS;
    var intl = getIntlLocale(locale);
    return date ? new Intl.DateTimeFormat(intl, options).format(new Date(date)) : null;
}

;// CONCATENATED MODULE: ./src/data/product-page-data/serialize-product-header.ts















function getProductVariationType(content) {
    var hasStone = !!(content === null || content === void 0 ? void 0 : content.product_stone);
    var hasMetal = hasStone ? false : !!(content === null || content === void 0 ? void 0 : content.product_metal);
    return hasStone ? "product_stone" : hasMetal ? "product_metal" : null;
}
function serializeVariations(data, locale) {
    return _serializeVariations.apply(this, arguments);
}
function _serializeVariations() {
    _serializeVariations = _async_to_generator(function(data, locale) {
        var ref, ref1, ref2, ref3, ref4, ref5, content, type, ref6, declinationProductsData, ref7, ref8, items, ref9, ref10, active;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    content = data === null || data === void 0 ? void 0 : data.content;
                    type = getProductVariationType(content);
                    if (!type) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        Storyblok.getAll("cdn/stories", _object_spread({
                            starts_with: "".concat(STORYBLOK_TYPES.PRODUCT, "/"),
                            resolve_relations: PRODUCT_PAGE,
                            resolve_links: "url",
                            cv: pageSbParams.cv,
                            filter_query: {
                                root_product: {
                                    in: content === null || content === void 0 ? void 0 : content.root_product
                                }
                            }
                        }, (ref6 = pageSbParams === null || pageSbParams === void 0 ? void 0 : pageSbParams.instance) !== null && ref6 !== void 0 ? ref6 : {}))
                    ];
                case 1:
                    declinationProductsData = _state.sent();
                    items = (ref8 = (ref1 = (ref = (ref7 = declinationProductsData === null || declinationProductsData === void 0 ? void 0 : declinationProductsData.map(function(product) {
                        var ref, ref1, ref2, ref3;
                        var ref4, ref5;
                        return _object_spread_props(_object_spread({}, (ref4 = serializeProductAttribute(product, locale)) !== null && ref4 !== void 0 ? ref4 : {}), {
                            label: (ref5 = product === null || product === void 0 ? void 0 : (ref = product.content) === null || ref === void 0 ? void 0 : (ref1 = ref[type]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : ref3.title) !== null && ref5 !== void 0 ? ref5 : null
                        });
                    })) !== null && ref7 !== void 0 ? ref7 : null) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        return item && item.label && item.link;
                    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                        if ((a === null || a === void 0 ? void 0 : a.label) < (b === null || b === void 0 ? void 0 : b.label)) return -1;
                        if ((a === null || a === void 0 ? void 0 : a.label) > (b === null || b === void 0 ? void 0 : b.label)) return 1;
                        return 0;
                    })) !== null && ref8 !== void 0 ? ref8 : [];
                    active = _object_spread_props(_object_spread({}, (ref9 = serializeProductAttribute(data, locale)) !== null && ref9 !== void 0 ? ref9 : {}), {
                        label: (ref10 = data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[type]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.content) === null || ref5 === void 0 ? void 0 : ref5.title) !== null && ref10 !== void 0 ? ref10 : null
                    });
                    return [
                        2,
                        {
                            items: items,
                            active: active
                        }
                    ];
            }
        });
    });
    return _serializeVariations.apply(this, arguments);
}
function serialize_product_header_serializeProductHeader(_) {
    return _serializeProductHeader.apply(this, arguments);
}
function _serializeProductHeader() {
    _serializeProductHeader = _async_to_generator(function(param) {
        var locale, primaryPageData, i18nFallbackFields, ref, ref1, ref2, ref3, ref4, ref5, content, ref6, productVariations, _tmp, informationSections, ref7, ref8, ref9, ref10, ref11, ref12;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = param.locale, primaryPageData = param.primaryPageData, i18nFallbackFields = param.i18nFallbackFields;
                    content = (ref5 = primaryPageData === null || primaryPageData === void 0 ? void 0 : primaryPageData.content) !== null && ref5 !== void 0 ? ref5 : null;
                    if (!(content === null || content === void 0 ? void 0 : content.root_product)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        serializeVariations(primaryPageData, locale)
                    ];
                case 1:
                    _tmp = (ref6 = _state.sent()) !== null && ref6 !== void 0 ? ref6 : null;
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = null;
                    _state.label = 3;
                case 3:
                    productVariations = _tmp;
                    informationSections = _to_consumable_array(isRTFilled(i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productDetails) ? [
                        {
                            headline: i18n.t(PRODUCT.EXPAND_PRODUCT_DETAILS),
                            text: i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productDetails
                        }
                    ] : []);
                    return [
                        2,
                        {
                            description: (ref7 = i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productDescription) !== null && ref7 !== void 0 ? ref7 : null,
                            productVariations: (productVariations === null || productVariations === void 0 ? void 0 : (ref = productVariations.items) === null || ref === void 0 ? void 0 : ref.length) > 0 ? productVariations : null,
                            sections: informationSections && (informationSections === null || informationSections === void 0 ? void 0 : informationSections.length) > 0 ? informationSections : null,
                            sizeGuide: (content === null || content === void 0 ? void 0 : content.size_guide) ? {
                                table: serializeTable(content === null || content === void 0 ? void 0 : (ref1 = content.size_guide) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : ref2.size_guide_table),
                                wysiwyg: (ref8 = content === null || content === void 0 ? void 0 : (ref3 = content.size_guide) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.wysiwyg) !== null && ref8 !== void 0 ? ref8 : null
                            } : null,
                            preOrder: {
                                isActive: (ref9 = content === null || content === void 0 ? void 0 : content.has_pre_order) !== null && ref9 !== void 0 ? ref9 : false,
                                deliveryDate: (content === null || content === void 0 ? void 0 : content.delay_days_pre_order) ? serializeDate(addDaysToDate(new Date(Date.now()).toString(), +(content === null || content === void 0 ? void 0 : content.delay_days_pre_order)), locale) : null
                            },
                            isSpecialOrder: (ref10 = content === null || content === void 0 ? void 0 : content.has_special_order_enabled) !== null && ref10 !== void 0 ? ref10 : false,
                            isStockAlert: (ref11 = content === null || content === void 0 ? void 0 : content.has_stock_alert) !== null && ref11 !== void 0 ? ref11 : false,
                            isAdjusting: (ref12 = content === null || content === void 0 ? void 0 : content.is_adjustable) !== null && ref12 !== void 0 ? ref12 : false,
                            adjustableOffset: (content === null || content === void 0 ? void 0 : content.adjustable_offset) ? +(content === null || content === void 0 ? void 0 : content.adjustable_offset) : 0
                        }
                    ];
            }
        });
    });
    return _serializeProductHeader.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/trailing-slash.ts
function trailingSlash(url) {
    return url ? url.slice(-1) === "/" ? url : "".concat(url, "/") : undefined;
}
function removeTrailingSlash(url) {
    var ref;
    return (ref = url.replace(/\/+$/, "")) !== null && ref !== void 0 ? ref : url;
}

// EXTERNAL MODULE: ./src/lib/link-resolver.ts + 3 modules
var link_resolver = __webpack_require__(3523);
;// CONCATENATED MODULE: ./src/data/serialize-breadcrumb.ts









function serialize_breadcrumb_formatFromUid(param) {
    var uid = param.uid, name = param.name, type = param.type, fullSlug = param.fullSlug, locale = param.locale;
    var ref, ref1, ref2;
    // Trapping the homepage to avoid displaying it twice
    if (type === STORYBLOK_TYPES.HOMEPAGE) {
        return {
            children: null,
            href: null
        };
    }
    var ref3;
    return {
        children: name ? capitalize(name) : uid ? capitalize((ref2 = replaceStringFromArray((ref1 = (ref = uid === null || uid === void 0 ? void 0 : uid.split("-")) === null || ref === void 0 ? void 0 : ref.join(" ")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), Object.values(_object_spread({}, STORYBLOK_TYPES, STORYBLOK_SUBTYPES)), "", "/")) === null || ref2 === void 0 ? void 0 : ref2.split("_").join(" ")) : null,
        href: (ref3 = linkResolver({
            content: {
                component: type
            },
            slug: uid,
            default_full_slug: fullSlug
        }, locale)) !== null && ref3 !== void 0 ? ref3 : null
    };
}
function serializeBreadcrumb(param) {
    var _rootLink = param.rootLink, rootLink = _rootLink === void 0 ? null : _rootLink, _items = param.items, items = _items === void 0 ? [] : _items, locale = param.locale;
    return [
        {
            children: i18n.t(GENERAL.HOME_PAGE),
            href: "/".concat(locale)
        }, 
    ].concat(_to_consumable_array(rootLink ? !Array.isArray(rootLink) ? [
        rootLink
    ] : rootLink : []), _to_consumable_array(items ? items.map(function(item, i) {
        return _object_spread({}, serialize_breadcrumb_formatFromUid(_object_spread_props(_object_spread({}, item), {
            locale: locale
        })), i === (items === null || items === void 0 ? void 0 : items.length) - 1 && {
            href: null
        });
    }) : [])).filter(function(link) {
        return link.children;
    });
}

;// CONCATENATED MODULE: ./src/data/product-page-data/serialize-product-breadcrumb.ts







function generateCategoryEntriesFromPageData(categories) {
    var ref;
    return [
        {
            uid: null,
            name: i18n.t(GENERAL.CATEGORIES),
            type: STORYBLOK_TYPES.CATEGORY_PAGE
        }, 
    ].concat(_to_consumable_array((ref = categories === null || categories === void 0 ? void 0 : categories.map(function(cat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var ref8;
        return _object_spread({
            uid: null,
            name: (ref8 = cat === null || cat === void 0 ? void 0 : (ref = cat.content) === null || ref === void 0 ? void 0 : ref.title) !== null && ref8 !== void 0 ? ref8 : null
        }, (cat === null || cat === void 0 ? void 0 : (ref1 = cat.content) === null || ref1 === void 0 ? void 0 : ref1.category_page_relation) ? {
            type: cat === null || cat === void 0 ? void 0 : (ref2 = cat.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category_page_relation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.component
        } : {}, (cat === null || cat === void 0 ? void 0 : (ref5 = cat.content) === null || ref5 === void 0 ? void 0 : ref5.category_page_relation) ? {
            fullSlug: cat === null || cat === void 0 ? void 0 : (ref6 = cat.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.category_page_relation) === null || ref7 === void 0 ? void 0 : ref7.default_full_slug
        } : {});
    })) !== null && ref !== void 0 ? ref : []));
}
function serialize_product_breadcrumb_serializeProductBreadcrumb(param) {
    var _pageData = param.pageData, pageData = _pageData === void 0 ? null : _pageData, categories = param.categories, locale = param.locale;
    var ref, ref1, ref2;
    var ref3;
    var categoryData = (ref3 = pageData === null || pageData === void 0 ? void 0 : (ref = pageData.content) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref3 !== void 0 ? ref3 : null;
    var itemsToFormat = [];
    if (categoryData) {
        var _itemsToFormat;
        (_itemsToFormat = itemsToFormat).push.apply(_itemsToFormat, _to_consumable_array(generateCategoryEntriesFromPageData(categories)));
    }
    var ref4;
    itemsToFormat.push({
        uid: pageData === null || pageData === void 0 ? void 0 : pageData.slug,
        type: pageData === null || pageData === void 0 ? void 0 : (ref2 = pageData.content) === null || ref2 === void 0 ? void 0 : ref2.component,
        fullSlug: (ref4 = pageData === null || pageData === void 0 ? void 0 : pageData.default_full_slug) !== null && ref4 !== void 0 ? ref4 : null,
        name: null
    });
    return [
        {
            children: i18n.t(GENERAL.HOME_PAGE),
            href: "/".concat(locale)
        }, 
    ].concat(_to_consumable_array(itemsToFormat ? itemsToFormat.map(function(item) {
        return formatFromUid(_object_spread_props(_object_spread({}, item), {
            locale: locale
        }));
    }) : [])).filter(function(link) {
        return link.children;
    });
}

// EXTERNAL MODULE: ./src/data/serialize-product-card.ts
var serialize_product_card = __webpack_require__(63472);
;// CONCATENATED MODULE: ./src/data/product-page-data/serialize-recommended-products.ts









var WANTED_RECOMMENDATIONS = 3;
function serialize_recommended_products_serializeRecommendationData(data, siblingsData) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7, ref8, ref9;
    return {
        categoryUUID: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.uuid) !== null && ref7 !== void 0 ? ref7 : null,
        designerUUID: (ref8 = data === null || data === void 0 ? void 0 : (ref3 = data.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.designer) === null || ref4 === void 0 ? void 0 : ref4.uuid) !== null && ref8 !== void 0 ? ref8 : null,
        currentStory: {
            uuid: data === null || data === void 0 ? void 0 : data.uuid,
            id: data === null || data === void 0 ? void 0 : data.id
        },
        siblingsStories: (ref9 = (ref6 = siblingsData === null || siblingsData === void 0 ? void 0 : (ref5 = siblingsData.items) === null || ref5 === void 0 ? void 0 : ref5.filter(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : item.uuid) !== (siblingsData === null || siblingsData === void 0 ? void 0 : (ref = siblingsData.active) === null || ref === void 0 ? void 0 : ref.uuid);
        })) === null || ref6 === void 0 ? void 0 : ref6.map(function(item) {
            return {
                uuid: item === null || item === void 0 ? void 0 : item.uuid,
                id: item === null || item === void 0 ? void 0 : item.storyID
            };
        })) !== null && ref9 !== void 0 ? ref9 : []
    };
}
/**
 * It takes a product page's data, and returns a list of recommended products
 * @param  - `rawData` - the raw data from Storyblok
 * @returns An object with an array of items.
 */ function serializeRecommendedProducts(_) {
    return _serializeRecommendedProducts.apply(this, arguments);
}
function _serializeRecommendedProducts() {
    _serializeRecommendedProducts = _async_to_generator(function(param) {
        var rawData, productVariationsData, locale, ref, ref1, ref2, categoryUUID, designerUUID, currentStory, siblingsStories, excludedIds, ref3, baseSBParams, filters, siblingsQueryParams, mainQueryParams, ref4, responseItems, ref5, ref6, ref7, ref8, siblingsResponse, ref9, ref10, ref11, ref12, categoryAndDesignerResponse, ref13, ref14, ref15, ref16, designerResponse, ref17, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    rawData = param.rawData, productVariationsData = param.productVariationsData, locale = param.locale;
                    ref2 = serialize_recommended_products_serializeRecommendationData(rawData, productVariationsData), categoryUUID = ref2.categoryUUID, designerUUID = ref2.designerUUID, currentStory = ref2.currentStory, siblingsStories = ref2.siblingsStories;
                    excludedIds = (ref = [
                        currentStory === null || currentStory === void 0 ? void 0 : currentStory.id, 
                    ].concat(_to_consumable_array((siblingsStories === null || siblingsStories === void 0 ? void 0 : siblingsStories.length) > 0 ? siblingsStories.map(function(sibling) {
                        return sibling === null || sibling === void 0 ? void 0 : sibling.id;
                    }) : []))) === null || ref === void 0 ? void 0 : ref.join(",");
                    baseSBParams = _object_spread({
                        resolve_links: "url",
                        starts_with: "".concat(STORYBLOK_TYPES.PRODUCT, "/"),
                        per_page: WANTED_RECOMMENDATIONS,
                        resolve_relations: PRODUCT_CARDS,
                        cv: pageSbParams.cv
                    }, (ref3 = pageSbParams === null || pageSbParams === void 0 ? void 0 : pageSbParams.instance) !== null && ref3 !== void 0 ? ref3 : {});
                    filters = {
                        categories: _object_spread({}, categoryUUID ? {
                            categories: {
                                in: designerUUID
                            }
                        } : {}),
                        designers: _object_spread({}, designerUUID ? {
                            designer: {
                                in: designerUUID
                            }
                        } : {})
                    };
                    siblingsQueryParams = _object_spread_props(_object_spread({}, baseSBParams), {
                        by_uuids: (ref1 = siblingsStories === null || siblingsStories === void 0 ? void 0 : siblingsStories.map(function(sibling) {
                            return sibling === null || sibling === void 0 ? void 0 : sibling.uuid;
                        })) === null || ref1 === void 0 ? void 0 : ref1.join(","),
                        excluding_ids: currentStory.id
                    });
                    mainQueryParams = _object_spread_props(_object_spread({}, baseSBParams), {
                        excluding_ids: excludedIds
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    responseItems = [];
                    if (!((siblingsStories === null || siblingsStories === void 0 ? void 0 : siblingsStories.length) > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            Storyblok.get("cdn/stories", siblingsQueryParams)
                        ])
                    ];
                case 2:
                    siblingsResponse = (ref8 = (ref5 = _state.sent()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.stories) !== null && ref8 !== void 0 ? ref8 : [];
                    if (siblingsResponse) {
                        responseItems.push(siblingsResponse);
                        mainQueryParams["per_page"] = mainQueryParams["per_page"] - (siblingsResponse === null || siblingsResponse === void 0 ? void 0 : siblingsResponse.length);
                    }
                    _state.label = 3;
                case 3:
                    if (!((categoryUUID || designerUUID) && (responseItems === null || responseItems === void 0 ? void 0 : responseItems.length) < WANTED_RECOMMENDATIONS)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            Storyblok.get("cdn/stories", _object_spread_props(_object_spread({}, mainQueryParams), {
                                filter_query: _object_spread({}, filters.categories, filters.designers)
                            }))
                        ])
                    ];
                case 4:
                    categoryAndDesignerResponse = (ref12 = (ref9 = _state.sent()) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.stories) !== null && ref12 !== void 0 ? ref12 : [];
                    if ((categoryAndDesignerResponse === null || categoryAndDesignerResponse === void 0 ? void 0 : categoryAndDesignerResponse.length) > 0) {
                        responseItems.push(categoryAndDesignerResponse);
                        mainQueryParams["per_page"] = mainQueryParams["per_page"] - (categoryAndDesignerResponse === null || categoryAndDesignerResponse === void 0 ? void 0 : categoryAndDesignerResponse.length);
                    }
                    if (!(mainQueryParams["per_page"] !== 0)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            Storyblok.get("cdn/stories", _object_spread_props(_object_spread({}, mainQueryParams), {
                                filter_query: _object_spread({}, filters.designers)
                            }))
                        ])
                    ];
                case 5:
                    designerResponse = (ref16 = (ref13 = _state.sent()) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : ref15.stories) !== null && ref16 !== void 0 ? ref16 : [];
                    if ((designerResponse === null || designerResponse === void 0 ? void 0 : designerResponse.length) > 0) {
                        responseItems.push(designerResponse);
                    }
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        (ref17 = Promise.all((ref4 = responseItems === null || responseItems === void 0 ? void 0 : responseItems.flat()) === null || ref4 === void 0 ? void 0 : ref4.map(function() {
                            var _ref = _async_to_generator(function(responseItem) {
                                var ref;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                serializeProductCard(responseItem, locale)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                (ref = _state.sent()) !== null && ref !== void 0 ? ref : null
                                            ];
                                    }
                                });
                            });
                            return function(responseItem) {
                                return _ref.apply(this, arguments);
                            };
                        }()))) !== null && ref17 !== void 0 ? ref17 : []
                    ];
                case 7:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        []
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _serializeRecommendedProducts.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/data/product-page-data/serializer.ts
















function trimAndSplit(strToTrim, strToReplace) {
    var ref;
    return (ref = strToTrim.replace(strToReplace, "").split("/")) === null || ref === void 0 ? void 0 : ref.filter(Boolean);
}
/**
 * Check wether a category is a sub category
 * @param category story
 * @returns boolean
 */ function isSubCategory(category) {
    var ref, ref1;
    var slugBase = "".concat(STORYBLOK_SUBTYPES.PRODUCT_ATTRIBUTES, "/").concat(STORYBLOK_SUBTYPES.PRODUCT_CATEGORIES, "/");
    var fullSlug = category === null || category === void 0 ? void 0 : category.default_full_slug;
    // Remove slug base from default slug (product_attributes/product_categories/) & split by '/'
    var splitted = (ref = fullSlug === null || fullSlug === void 0 ? void 0 : fullSlug.replace(slugBase, "")) === null || ref === void 0 ? void 0 : ref.split("/");
    // If there are more than 1 chained category then this is a subcategory
    // eg: necklaces/long -> ["necklaces", "long"]
    return ((ref1 = splitted === null || splitted === void 0 ? void 0 : splitted.filter(Boolean)) === null || ref1 === void 0 ? void 0 : ref1.length) > 1;
}
/**
 * Retrieve all chained categories from a category story
 * @param initialCategories story
 * @param locale string
 * @returns story[]
 */ function getCategoriesFromCategoryAttributes(initialCategories, locale) {
    return _getCategoriesFromCategoryAttributes.apply(this, arguments);
}
function _getCategoriesFromCategoryAttributes() {
    _getCategoriesFromCategoryAttributes = (0,src_async_to_generator/* default */.Z)(function(initialCategories, locale) {
        var ref, ref1, categories, lang, slugBase, reconstructedSlugs, ref2, uniqueSlugsToFetch, fetchedCategories, _tmp, categoriesArray;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If the initial categories are not defined, return empty array
                    if (!initialCategories || !(initialCategories === null || initialCategories === void 0 ? void 0 : initialCategories.length)) return [
                        2,
                        []
                    ];
                    categories = initialCategories === null || initialCategories === void 0 ? void 0 : initialCategories.filter(function(c) {
                        return c === null || c === void 0 ? void 0 : c.default_full_slug;
                    });
                    // If there are no categories with valid default slug, return empty array
                    if (!categories || !(categories === null || categories === void 0 ? void 0 : categories.length)) return [
                        2,
                        []
                    ];
                    lang = (0,locales/* getLang */.VQ)(locale);
                    slugBase = "".concat(storyblok_types/* STORYBLOK_SUBTYPES.PRODUCT_ATTRIBUTES */.ru.PRODUCT_ATTRIBUTES, "/").concat(storyblok_types/* STORYBLOK_SUBTYPES.PRODUCT_CATEGORIES */.ru.PRODUCT_CATEGORIES, "/");
                    reconstructedSlugs = (ref = categories === null || categories === void 0 ? void 0 : categories.filter(function(entry) {
                        return entry && (entry === null || entry === void 0 ? void 0 : entry.default_full_slug);
                    })) === null || ref === void 0 ? void 0 : ref.reduce(function(accc, entry) {
                        /**
       * Our category attribute default_full_slug will be something like
        `/product_attributes/products_categories/necklaces/long-necklaces`
      */ var fullSlug = removeTrailingSlash(entry.default_full_slug);
                        /**
       * Split all categories from full slug
       * "product_atributes/product_categories/colliers/colliers-longs" -> ["colliers", "colliers-longs"]
       */ var slugs = trimAndSplit(fullSlug, slugBase);
                        // Loop over entries to get an array of all category & promise them all later
                        var fullSlugs = slugs.reduce(function(acc, slug, index, array) {
                            // If the current slug is the initial category, loop over next
                            if (slug === (entry === null || entry === void 0 ? void 0 : entry.slug) || (categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
                                return (category === null || category === void 0 ? void 0 : category.slug) === slug;
                            }))) {
                                return acc;
                            }
                            /**
         * Get previous entries as story prefix
         * ['colliers', 'colliers-longs'] -> 'colliers/colliers-longs'
         */ var prefix = array.slice(0, index).join("/");
                            // Reconstruct full slug with prefix and slug values
                            return (0,src_to_consumable_array/* default */.Z)(acc).concat([
                                "".concat(slugBase).concat(prefix ? "".concat(prefix, "/") : "").concat(slug)
                            ]);
                        }, []);
                        return (0,src_to_consumable_array/* default */.Z)(accc).concat((0,src_to_consumable_array/* default */.Z)(fullSlugs));
                    }, []);
                    uniqueSlugsToFetch = (ref2 = reconstructedSlugs === null || reconstructedSlugs === void 0 ? void 0 : reconstructedSlugs.filter(function(item, index, arr) {
                        return item && arr.indexOf(item) === index;
                    })) !== null && ref2 !== void 0 ? ref2 : [];
                    if (!(uniqueSlugsToFetch.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(uniqueSlugsToFetch === null || uniqueSlugsToFetch === void 0 ? void 0 : uniqueSlugsToFetch.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(slug) {
                                var ref, ref1, sbParams, ref2, category;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            sbParams = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                resolve_relations: [
                                                    fetch_links/* PRODUCT_CATEGORIES */.Zy
                                                ],
                                                cv: storyblok/* pageSbParams.cv */.MG.cv
                                            }, (ref1 = storyblok/* pageSbParams */.MG === null || storyblok/* pageSbParams */.MG === void 0 ? void 0 : storyblok/* pageSbParams.instance */.MG.instance) !== null && ref1 !== void 0 ? ref1 : {}), {
                                                language: lang
                                            });
                                            return [
                                                4,
                                                storyblok/* default.get */.ZP.get("cdn/stories/".concat(slug), sbParams)
                                            ];
                                        case 1:
                                            category = (ref2 = _state.sent()) !== null && ref2 !== void 0 ? ref2 : {};
                                            return [
                                                2,
                                                category === null || category === void 0 ? void 0 : (ref = category.data) === null || ref === void 0 ? void 0 : ref.story
                                            ];
                                    }
                                });
                            });
                            return function(slug) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = [];
                    _state.label = 3;
                case 3:
                    fetchedCategories = _tmp;
                    categoriesArray = (ref1 = (0,src_to_consumable_array/* default */.Z)(fetchedCategories).concat((0,src_to_consumable_array/* default */.Z)(categories))) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                        // And sort them by hierarchy order
                        // main category > ...subCategories
                        var trimmedSlugA = trimAndSplit(a === null || a === void 0 ? void 0 : a.default_full_slug, slugBase);
                        var trimmedSlugB = trimAndSplit(b === null || b === void 0 ? void 0 : b.default_full_slug, slugBase);
                        return (trimmedSlugA === null || trimmedSlugA === void 0 ? void 0 : trimmedSlugA.length) - (trimmedSlugB === null || trimmedSlugB === void 0 ? void 0 : trimmedSlugB.length);
                    });
                    return [
                        2,
                        categoriesArray
                    ];
            }
        });
    });
    return _getCategoriesFromCategoryAttributes.apply(this, arguments);
}
function serializeProductPage(primaryPageData, serializedPageData, _) {
    return _serializeProductPage.apply(this, arguments);
}
function _serializeProductPage() {
    _serializeProductPage = _async_to_generator(function(primaryPageData, serializedPageData, param) {
        var type, uid, locale, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, serializedProduct, ref10, productHeader, _tmp, overridenMetas, ref11, ref12, recommendationData, filterQuery, ref13, sbParams, ref14, linkedDesigner, ref15, linkedDesignerStory, ref16, ref17, ref18, ref19, ref20;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = param.type, uid = param.uid, locale = param.locale;
                    return [
                        4,
                        serializeProduct({
                            locale: locale,
                            data: primaryPageData
                        })
                    ];
                case 1:
                    serializedProduct = (ref9 = _state.sent()) !== null && ref9 !== void 0 ? ref9 : null;
                    _tmp = [
                        {}
                    ];
                    return [
                        4,
                        serializeProductHeader({
                            locale: locale,
                            primaryPageData: primaryPageData,
                            i18nFallbackFields: (ref10 = serializedProduct === null || serializedProduct === void 0 ? void 0 : serializedProduct.i18nFallbackFields) !== null && ref10 !== void 0 ? ref10 : {}
                        })
                    ];
                case 2:
                    productHeader = _object_spread.apply(void 0, _tmp.concat(_state.sent(), serializedProduct));
                    overridenMetas = serializeOverridenMetas(serializedPageData === null || serializedPageData === void 0 ? void 0 : serializedPageData.metas, productHeader);
                    recommendationData = (ref12 = serializeRecommendationData(primaryPageData, (ref11 = productHeader === null || productHeader === void 0 ? void 0 : productHeader.productVariations) !== null && ref11 !== void 0 ? ref11 : null)) !== null && ref12 !== void 0 ? ref12 : null;
                    filterQuery = {};
                    filterQuery["relation"] = {
                        in: primaryPageData === null || primaryPageData === void 0 ? void 0 : (ref = primaryPageData.content) === null || ref === void 0 ? void 0 : (ref1 = ref.designer) === null || ref1 === void 0 ? void 0 : ref1.uuid
                    };
                    sbParams = _object_spread({
                        content_type: STORYBLOK_TYPES.DESIGNER,
                        filter_query: filterQuery,
                        cv: pageSbParams.cv
                    }, (ref13 = pageSbParams === null || pageSbParams === void 0 ? void 0 : pageSbParams.instance) !== null && ref13 !== void 0 ? ref13 : {});
                    return [
                        4,
                        Storyblok.get("cdn/stories", sbParams)
                    ];
                case 3:
                    linkedDesigner = (ref14 = _state.sent()) !== null && ref14 !== void 0 ? ref14 : {};
                    linkedDesignerStory = (ref15 = linkedDesigner === null || linkedDesigner === void 0 ? void 0 : (ref2 = linkedDesigner.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.stories) === null || ref3 === void 0 ? void 0 : ref3[0]) !== null && ref15 !== void 0 ? ref15 : null;
                    return [
                        2,
                        _object_spread_props(_object_spread({}, serializedPageData), {
                            metas: overridenMetas,
                            breadcrumb: serializeProductBreadcrumb({
                                pageData: primaryPageData,
                                categories: (ref16 = serializedProduct === null || serializedProduct === void 0 ? void 0 : serializedProduct.categories) !== null && ref16 !== void 0 ? ref16 : [],
                                locale: locale
                            }),
                            currentProduct: {
                                locale: locale,
                                uid: uid
                            },
                            recommendationData: recommendationData,
                            productHeader: _object_spread_props(_object_spread({}, productHeader ? productHeader : null), {
                                productDesigner: _object_spread_props(_object_spread({}, serializeLink(linkedDesignerStory, locale)), {
                                    children: (ref17 = primaryPageData === null || primaryPageData === void 0 ? void 0 : (ref4 = primaryPageData.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.designer) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.content) === null || ref6 === void 0 ? void 0 : ref6.title) !== null && ref17 !== void 0 ? ref17 : null
                                }),
                                uuid: (ref18 = primaryPageData === null || primaryPageData === void 0 ? void 0 : primaryPageData.uuid) !== null && ref18 !== void 0 ? ref18 : null,
                                type: type,
                                stockAlertProps: {
                                    productName: (ref19 = serializedProduct === null || serializedProduct === void 0 ? void 0 : serializedProduct.productName) !== null && ref19 !== void 0 ? ref19 : null,
                                    productImage: (ref20 = serializedProduct === null || serializedProduct === void 0 ? void 0 : (ref7 = serializedProduct.cardImage) === null || ref7 === void 0 ? void 0 : ref7.src) !== null && ref20 !== void 0 ? ref20 : null,
                                    redirectLink: (serializedProduct === null || serializedProduct === void 0 ? void 0 : (ref8 = serializedProduct.link) === null || ref8 === void 0 ? void 0 : ref8.href) ? "".concat("https://www.whitebirdjewellery.com").concat(serializedProduct.link.href) : null
                                }
                            })
                        })
                    ];
            }
        });
    });
    return _serializeProductPage.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/Abstracts/Image/loader.ts
var loader = __webpack_require__(6107);
;// CONCATENATED MODULE: ./src/data/serialize-image.ts



/**
 * Image serializer
 * @param image
 * @param loaderParams
 * @returns Serialized image
 */ function serializeImage(image, loaderParams) {
    var ref;
    var src = (ref = image === null || image === void 0 ? void 0 : image.filename) !== null && ref !== void 0 ? ref : image === null || image === void 0 ? void 0 : image.src;
    var ref1;
    var alt = (ref1 = image === null || image === void 0 ? void 0 : image.alt) !== null && ref1 !== void 0 ? ref1 : null;
    var newImageSrc;
    var ref2 = (0,_sliced_to_array/* default */.Z)(src ? src.split("/")[5].split("x") : [], 2), width = ref2[0], height = ref2[1];
    var dimensions = {
        width: width ? parseInt(width) : null,
        height: height ? parseInt(height) : null
    };
    if (src) {
        var url = new URL(src);
        newImageSrc = "".concat(url === null || url === void 0 ? void 0 : url.origin).concat(url === null || url === void 0 ? void 0 : url.pathname);
        newImageSrc = loaderParams && src.indexOf(".svg") === -1 ? (0,loader/* imageLoaderStoryblok */.y)((0,src_object_spread/* default */.Z)({
            src: newImageSrc
        }, loaderParams)) : newImageSrc;
    }
    return src ? {
        src: newImageSrc !== null && newImageSrc !== void 0 ? newImageSrc : src,
        width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
        height: dimensions === null || dimensions === void 0 ? void 0 : dimensions.height,
        alt: alt
    } : null;
}

// EXTERNAL MODULE: ./src/data/serialize-shopify-image.ts
var serialize_shopify_image = __webpack_require__(8145);
;// CONCATENATED MODULE: ./src/data/serialize-storyblok-product-data.ts









function serializeStoryblokProductData(_) {
    return _serializeStoryblokProductData.apply(this, arguments);
}
function _serializeStoryblokProductData() {
    _serializeStoryblokProductData = (0,src_async_to_generator/* default */.Z)(function(param) {
        var locale, data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, content, type, ref16, variantsItems, ref17, isUniquePiece, ref18, isExclusivity, ref19, isNew, ref20, firstPublishedAtTime, ref21, lastBackInStockTime, categories, ref22, ref23, algoliaCategoriesFacets, ref24, trackingCategories, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = param.locale, data = param.data;
                    content = (ref15 = data === null || data === void 0 ? void 0 : data.content) !== null && ref15 !== void 0 ? ref15 : null;
                    type = getProductVariationType(data === null || data === void 0 ? void 0 : data.content);
                    variantsItems = (ref16 = (ref1 = content === null || content === void 0 ? void 0 : (ref = content.image_variant) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return {
                            image: (0,serialize_shopify_image/* default */.Z)(item)
                        };
                    })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                        return item;
                    })) !== null && ref16 !== void 0 ? ref16 : null;
                    isUniquePiece = (ref17 = content === null || content === void 0 ? void 0 : content.unique_piece) !== null && ref17 !== void 0 ? ref17 : false;
                    isExclusivity = (ref18 = content === null || content === void 0 ? void 0 : content.exclusivity) !== null && ref18 !== void 0 ? ref18 : false;
                    isNew = (ref19 = content === null || content === void 0 ? void 0 : content.is_new) !== null && ref19 !== void 0 ? ref19 : false;
                    firstPublishedAtTime = new Date((ref20 = data === null || data === void 0 ? void 0 : data.first_published_at) !== null && ref20 !== void 0 ? ref20 : null).getTime();
                    lastBackInStockTime = new Date((ref21 = content === null || content === void 0 ? void 0 : content.shopify_last_back_in_stock_datetime) !== null && ref21 !== void 0 ? ref21 : null).getTime();
                    return [
                        4,
                        getCategoriesFromCategoryAttributes(content === null || content === void 0 ? void 0 : content.categories, locale)
                    ];
                case 1:
                    categories = _state.sent();
                    algoliaCategoriesFacets = (ref23 = (ref2 = categories === null || categories === void 0 ? void 0 : categories.map(function(cat) {
                        var ref;
                        return (ref22 = cat === null || cat === void 0 ? void 0 : (ref = cat.content) === null || ref === void 0 ? void 0 : ref.title) !== null && ref22 !== void 0 ? ref22 : null;
                    })) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                        return item;
                    })) !== null && ref23 !== void 0 ? ref23 : [];
                    trackingCategories = (ref24 = categories === null || categories === void 0 ? void 0 : categories.map(function(cat) {
                        var ref, ref1, ref2;
                        return (cat === null || cat === void 0 ? void 0 : (ref = cat.content) === null || ref === void 0 ? void 0 : (ref1 = ref.tracking_title) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? cat === null || cat === void 0 ? void 0 : (ref2 = cat.content) === null || ref2 === void 0 ? void 0 : ref2.tracking_title : cat === null || cat === void 0 ? void 0 : cat.name;
                    })) !== null && ref24 !== void 0 ? ref24 : [];
                    return [
                        2,
                        {
                            uuid: (ref25 = data === null || data === void 0 ? void 0 : data.uuid) !== null && ref25 !== void 0 ? ref25 : null,
                            slug: (ref26 = data === null || data === void 0 ? void 0 : data.slug) !== null && ref26 !== void 0 ? ref26 : null,
                            algoliaCategoriesFacets: algoliaCategoriesFacets,
                            cardImage: (ref27 = serializeImage(content === null || content === void 0 ? void 0 : content.card_image)) !== null && ref27 !== void 0 ? ref27 : null,
                            cardImageHover: (ref28 = serializeImage(content === null || content === void 0 ? void 0 : content.card_image_hover)) !== null && ref28 !== void 0 ? ref28 : null,
                            categories: categories,
                            trackingCategories: trackingCategories,
                            category: (ref29 = (ref4 = content === null || content === void 0 ? void 0 : (ref3 = content.categories) === null || ref3 === void 0 ? void 0 : ref3.map(function(category) {
                                return category === null || category === void 0 ? void 0 : category.name;
                            })) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
                                return item;
                            })) !== null && ref29 !== void 0 ? ref29 : null,
                            variantsItems: variantsItems,
                            sustainabilityTags: (ref31 = (ref6 = content === null || content === void 0 ? void 0 : (ref5 = content.product_sustainability_tags) === null || ref5 === void 0 ? void 0 : ref5.map(function(tag) {
                                var ref;
                                return (ref30 = (ref = tag.content) === null || ref === void 0 ? void 0 : ref.title) !== null && ref30 !== void 0 ? ref30 : null;
                            })) === null || ref6 === void 0 ? void 0 : ref6.filter(Boolean)) !== null && ref31 !== void 0 ? ref31 : [],
                            productStatusTags: {
                                isUniquePiece: isUniquePiece,
                                isExclusivity: isExclusivity,
                                isNew: isNew,
                                lastBackInStockTime: lastBackInStockTime > 0 ? lastBackInStockTime : null,
                                firstPublishedAtTime: firstPublishedAtTime > 0 ? firstPublishedAtTime : null
                            },
                            customTags: (ref32 = (ref8 = content === null || content === void 0 ? void 0 : (ref7 = content.custom_tags) === null || ref7 === void 0 ? void 0 : ref7.map(function(content) {
                                return content === null || content === void 0 ? void 0 : content.text;
                            })) === null || ref8 === void 0 ? void 0 : ref8.filter(Boolean)) !== null && ref32 !== void 0 ? ref32 : [],
                            productDesigner: (content === null || content === void 0 ? void 0 : (ref9 = content.designer) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.content) === null || ref10 === void 0 ? void 0 : ref10.title) ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,serialize_link/* default */.Z)(content === null || content === void 0 ? void 0 : content.designer, locale)), {
                                children: (ref33 = content === null || content === void 0 ? void 0 : (ref11 = content.designer) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.content) === null || ref12 === void 0 ? void 0 : ref12.title) !== null && ref33 !== void 0 ? ref33 : null
                            }) : null,
                            subtitle: (ref34 = content === null || content === void 0 ? void 0 : content.subtitle) !== null && ref34 !== void 0 ? ref34 : null,
                            text: (ref35 = content === null || content === void 0 ? void 0 : content.text) !== null && ref35 !== void 0 ? ref35 : null,
                            link: (0,serialize_link/* default */.Z)(data, locale),
                            items: [],
                            variation: (ref36 = content === null || content === void 0 ? void 0 : (ref13 = content[type]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : ref14.title) !== null && ref36 !== void 0 ? ref36 : null,
                            hasStockAlert: (ref37 = content === null || content === void 0 ? void 0 : content.has_stock_alert) !== null && ref37 !== void 0 ? ref37 : false,
                            isSpecialOrder: (ref38 = content === null || content === void 0 ? void 0 : content.has_special_order_enabled) !== null && ref38 !== void 0 ? ref38 : false,
                            isPreOrder: (ref39 = content === null || content === void 0 ? void 0 : content.has_pre_order) !== null && ref39 !== void 0 ? ref39 : false,
                            isAdjusting: (ref40 = content === null || content === void 0 ? void 0 : content.is_adjustable) !== null && ref40 !== void 0 ? ref40 : false,
                            adjustableOffset: (content === null || content === void 0 ? void 0 : content.adjustable_offset) ? +(content === null || content === void 0 ? void 0 : content.adjustable_offset) : 0
                        }
                    ];
            }
        });
    });
    return _serializeStoryblokProductData.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/data/serialize-shopify-product-data.ts + 4 modules
var serialize_shopify_product_data = __webpack_require__(39294);
;// CONCATENATED MODULE: ./src/data/serialize-storyblok-shopify-data.ts

function serializeStoryblokShopifyData(param) {
    var shopifyProduct = param.shopifyProduct, storyblokContent = param.storyblokContent, locale = param.locale;
    var ref;
    return (0,serialize_shopify_product_data/* serializeShopifyProductData */.u)({
        isAdjustable: storyblokContent === null || storyblokContent === void 0 ? void 0 : storyblokContent.is_adjustable,
        adjustableOffsetValue: (storyblokContent === null || storyblokContent === void 0 ? void 0 : storyblokContent.adjustable_offset) ? +(storyblokContent === null || storyblokContent === void 0 ? void 0 : storyblokContent.adjustable_offset) : 0,
        productVariants: shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.variants,
        productImages: shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.images,
        media: (ref = shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.media) !== null && ref !== void 0 ? ref : null,
        shopifyProductId: shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.id,
        locale: locale
    });
}

// EXTERNAL MODULE: ./src/utils/shopify-ids.ts
var shopify_ids = __webpack_require__(54527);
;// CONCATENATED MODULE: ./src/data/serialize-product.ts













var PRODUCT_MEDIA_VIDEO = "VIDEO";
var PRODUCT_MEDIA_IMAGE = "IMAGE";
function serialize_product_serializeProduct(_) {
    return _serializeProduct.apply(this, arguments);
}
function _serializeProduct() {
    _serializeProduct = (0,src_async_to_generator/* default */.Z)(function(param) {
        var locale, data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, storyblokContent, hasV2ShopifyData, ref14, shopifyProductFromStoryblok, ref15, shopifyProductId, sfProduct, ref16, serializedShopifyProduct, i18nFallbackFields, price, ref17, ref18, ref19, ref20, ref21, ref22, ref23, trackingData, ref24, ref25, ref26, ref27, ref28, ref29;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = param.locale, data = param.data;
                    return [
                        4,
                        serializeStoryblokProductData({
                            locale: locale,
                            data: data
                        })
                    ];
                case 1:
                    storyblokContent = _state.sent();
                    hasV2ShopifyData = (data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.shopify_product_v2) ? true : false;
                    shopifyProductFromStoryblok = hasV2ShopifyData ? data === null || data === void 0 ? void 0 : (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.shopify_product_v2 : (ref14 = data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2.shopify_product_id) !== null && ref14 !== void 0 ? ref14 : null;
                    if (!shopifyProductFromStoryblok) return [
                        2,
                        null
                    ];
                    shopifyProductId = hasV2ShopifyData ? shopifyProductFromStoryblok === null || shopifyProductFromStoryblok === void 0 ? void 0 : (ref3 = shopifyProductFromStoryblok.data) === null || ref3 === void 0 ? void 0 : ref3.id : (ref15 = (shopifyProductFromStoryblok === null || shopifyProductFromStoryblok === void 0 ? void 0 : (ref4 = shopifyProductFromStoryblok.content) === null || ref4 === void 0 ? void 0 : ref4.shopify_id) || (0,shopify_ids/* isGID */.C9)("Product", shopifyProductFromStoryblok) && shopifyProductFromStoryblok) !== null && ref15 !== void 0 ? ref15 : null;
                    if (!shopifyProductId) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        (0,product_by_id/* getSfProduct */.e)({
                            id: shopifyProductId,
                            includeFeaturedImage: true,
                            storeAvailabilityFirst: 100,
                            imagesFirst: 50,
                            metafieldKeys: metafields/* SHOPIFY_PRODUCT_METAFIELDS_KEYS */.zb,
                            metafieldVariantsKeys: metafields/* SHOPIFY_VARIANT_METAFIELDS_KEYS */.RW,
                            locale: locale
                        })
                    ];
                case 2:
                    sfProduct = _state.sent();
                    if (!sfProduct) return [
                        2,
                        null
                    ];
                    serializedShopifyProduct = (ref16 = serializeStoryblokShopifyData({
                        shopifyProduct: sfProduct,
                        storyblokContent: storyblokContent,
                        locale: locale
                    })) !== null && ref16 !== void 0 ? ref16 : null;
                    i18nFallbackFields = serializeFallbackI18nFields({
                        shopifyProduct: sfProduct,
                        rawStoryblokData: data,
                        locale: locale
                    });
                    price = +(serializedShopifyProduct === null || serializedShopifyProduct === void 0 ? void 0 : (ref5 = serializedShopifyProduct.unformattedPrice) === null || ref5 === void 0 ? void 0 : ref5.amount);
                    trackingData = (0,useTrackProductCardsList/* fromProductCardPropsToProductTrackingData */.w)({
                        name: (ref17 = i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productName) !== null && ref17 !== void 0 ? ref17 : null,
                        designer: (ref18 = storyblokContent === null || storyblokContent === void 0 ? void 0 : (ref6 = storyblokContent.productDesigner) === null || ref6 === void 0 ? void 0 : ref6.children) !== null && ref18 !== void 0 ? ref18 : "",
                        shopifyId: (ref19 = serializedShopifyProduct === null || serializedShopifyProduct === void 0 ? void 0 : serializedShopifyProduct.shopifyId) !== null && ref19 !== void 0 ? ref19 : null,
                        categories: (ref20 = storyblokContent === null || storyblokContent === void 0 ? void 0 : storyblokContent.trackingCategories) !== null && ref20 !== void 0 ? ref20 : null,
                        variantId: (ref21 = serializedShopifyProduct === null || serializedShopifyProduct === void 0 ? void 0 : (ref7 = serializedShopifyProduct.variants) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.id) !== null && ref21 !== void 0 ? ref21 : null,
                        sku: (ref22 = serializedShopifyProduct === null || serializedShopifyProduct === void 0 ? void 0 : (ref9 = serializedShopifyProduct.variants) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.sku) !== null && ref22 !== void 0 ? ref22 : "",
                        size: (ref23 = serializedShopifyProduct === null || serializedShopifyProduct === void 0 ? void 0 : (ref11 = serializedShopifyProduct.variants) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.title) !== null && ref23 !== void 0 ? ref23 : null,
                        priceAmount: !isNaN(price) ? price : null
                    }, {});
                    return [
                        2,
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, storyblokContent !== null && storyblokContent !== void 0 ? storyblokContent : {}, serializedShopifyProduct !== null && serializedShopifyProduct !== void 0 ? serializedShopifyProduct : {}), {
                            productName: (ref24 = i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productName) !== null && ref24 !== void 0 ? ref24 : null,
                            i18nFallbackFields: i18nFallbackFields,
                            trackingData: trackingData,
                            jsonLD: serializeJSONLD(storyblokContent, serializedShopifyProduct, (ref13 = (0,serialize_link/* default */.Z)(data, locale)) === null || ref13 === void 0 ? void 0 : ref13.href, (ref26 = (ref25 = i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productName) !== null && ref25 !== void 0 ? ref25 : data === null || data === void 0 ? void 0 : data.name) !== null && ref26 !== void 0 ? ref26 : null, (ref29 = (ref28 = (ref27 = i18nFallbackFields === null || i18nFallbackFields === void 0 ? void 0 : i18nFallbackFields.productDescription) !== null && ref27 !== void 0 ? ref27 : data === null || data === void 0 ? void 0 : data.product_description) !== null && ref28 !== void 0 ? ref28 : data === null || data === void 0 ? void 0 : data.name) !== null && ref29 !== void 0 ? ref29 : null)
                        })
                    ];
            }
        });
    });
    return _serializeProduct.apply(this, arguments);
}


/***/ }),

/***/ 8145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ serializeShopifyImage; }
/* harmony export */ });
/**
 * Image serializer
 * @param image
 * @returns Serialized image
 */ function serializeShopifyImage(image) {
    var ref;
    var src = (ref = image === null || image === void 0 ? void 0 : image.url) !== null && ref !== void 0 ? ref : null;
    var ref1;
    var alt = (ref1 = image === null || image === void 0 ? void 0 : image.altText) !== null && ref1 !== void 0 ? ref1 : null;
    var width = image === null || image === void 0 ? void 0 : image.width;
    var height = image === null || image === void 0 ? void 0 : image.height;
    var dimensions = {
        width: width ? width : null,
        height: height ? height : null
    };
    return src ? {
        src: src !== null && src !== void 0 ? src : null,
        width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
        height: dimensions === null || dimensions === void 0 ? void 0 : dimensions.height,
        alt: alt
    } : null;
}


/***/ }),

/***/ 39294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ serializeShopifyProductData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/keep-available-variants.ts
function keepAvailableVariants(variants) {
    var ref;
    var ref1;
    return (ref1 = ((ref = variants === null || variants === void 0 ? void 0 : variants.filter(function(variant) {
        return variant === null || variant === void 0 ? void 0 : variant.availableForSale;
    })) === null || ref === void 0 ? void 0 : ref.length) > 0) !== null && ref1 !== void 0 ? ref1 : false;
}

// EXTERNAL MODULE: ./src/utils/is-size-or-default-variant-name.ts
var is_size_or_default_variant_name = __webpack_require__(64349);
;// CONCATENATED MODULE: ./src/utils/check-adjustable-variants-lookup.ts
/**
 * It checks if there are any sellable variants within a given range of the current variant
 * @param currentVariant - The current variant that is being displayed
 * @param allVariants - An array of all variants for the current product
 * @param currentIndex - The index of the current variant in the array of all variants
 * @param offset - The number of variants to check on either side of the current variant.
 * @returns A boolean value.
 */ function lookupAdjustableVariants(currentVariant, allVariants, currentIndex, offset) {
    var minVariantsIndex = 0;
    var maxVariantsIndex = (allVariants === null || allVariants === void 0 ? void 0 : allVariants.length) - 1;
    var boundLeftOffset = currentIndex - offset;
    var boundRightOffset = currentIndex + offset;
    var notSellableVariantCount = 0;
    var foundVariantToSell = null;
    if (boundLeftOffset < minVariantsIndex) {
        boundLeftOffset = minVariantsIndex;
    }
    if (boundRightOffset > maxVariantsIndex) {
        boundRightOffset = maxVariantsIndex;
    }
    var entriesToCheck = boundRightOffset - boundLeftOffset;
    for(var i = boundLeftOffset; i <= boundRightOffset; i++){
        var currentLookupVariant = allVariants === null || allVariants === void 0 ? void 0 : allVariants[i];
        if ((currentLookupVariant === null || currentLookupVariant === void 0 ? void 0 : currentLookupVariant.id) !== (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.id)) {
            if ((currentLookupVariant === null || currentLookupVariant === void 0 ? void 0 : currentLookupVariant.availableForSale) && !foundVariantToSell) {
                foundVariantToSell = currentLookupVariant;
                notSellableVariantCount = notSellableVariantCount + 1;
            }
        }
    }
    return {
        isVariantSellable: notSellableVariantCount !== entriesToCheck && foundVariantToSell !== null,
        variantToSell: foundVariantToSell
    };
}

;// CONCATENATED MODULE: ./src/data/serialize-adjustable-variants.ts




/**
 * It takes a list of variants, and returns a list of variants with an additional property called
 * isVariantSellable
 * @param variants - the array of variants
 * @param offset - The number of variants to skip before the first sellable variant.
 * @returns An array of variants with the adjustments properties set
 */ function serializeAdjustableVariants(variants, offset) {
    var compiledVariants = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        var ref;
        var variantOptions = variant === null || variant === void 0 ? void 0 : variant.selectedOptions;
        var ref1;
        var hasSizeOption = (ref1 = ((ref = variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.filter(function(option) {
            var optionName = option === null || option === void 0 ? void 0 : option.name;
            return (0,is_size_or_default_variant_name/* isSizeOrDefaultVariantName */.j)(optionName);
        })) === null || ref === void 0 ? void 0 : ref.length) > 0) !== null && ref1 !== void 0 ? ref1 : false;
        if (hasSizeOption) {
            var siblings = [];
            var isVariantSellable = true;
            var adjustableVariantToSell = variant;
            var isVariantAdjusting = (variant === null || variant === void 0 ? void 0 : variant.availableForSale) === false;
            if (isVariantAdjusting) {
                if ((variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.length) > 1) {
                    // Group siblings by the second option
                    var secondOption = variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions[1];
                    siblings = variants === null || variants === void 0 ? void 0 : variants.filter(function(sibling) {
                        var ref, ref1, ref2, ref3;
                        return (sibling === null || sibling === void 0 ? void 0 : (ref = sibling.selectedOptions) === null || ref === void 0 ? void 0 : (ref1 = ref[1]) === null || ref1 === void 0 ? void 0 : ref1.name) === (secondOption === null || secondOption === void 0 ? void 0 : secondOption.name) && (sibling === null || sibling === void 0 ? void 0 : (ref2 = sibling.selectedOptions) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[1]) === null || ref3 === void 0 ? void 0 : ref3.value) === (secondOption === null || secondOption === void 0 ? void 0 : secondOption.value);
                    });
                } else {
                    siblings = variants;
                }
                var currentVariantIndexAmongSiblings = siblings === null || siblings === void 0 ? void 0 : siblings.findIndex(function(currentSibling, index) {
                    return currentSibling.id === variant.id;
                });
                var lookupCheck = lookupAdjustableVariants(variant, siblings, currentVariantIndexAmongSiblings, offset);
                isVariantSellable = lookupCheck === null || lookupCheck === void 0 ? void 0 : lookupCheck.isVariantSellable;
                if (isVariantSellable && lookupCheck.variantToSell) {
                    adjustableVariantToSell = lookupCheck.variantToSell;
                }
            }
            var variantToPush = variant;
            if (isVariantSellable && adjustableVariantToSell) {
                variantToPush = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, adjustableVariantToSell), {
                    title: variant.title,
                    selectedOptions: variant.selectedOptions
                });
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variantToPush), {
                isVariantAdjusting: isVariantAdjusting,
                isVariantSellable: isVariantSellable,
                availableForSale: isVariantSellable !== false
            });
        } else {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                isVariantAdjusting: false,
                isVariantSellable: true
            });
        }
    });
    return compiledVariants;
}

// EXTERNAL MODULE: ./src/data/serialize-price.ts
var serialize_price = __webpack_require__(99338);
// EXTERNAL MODULE: ./src/data/serialize-product.ts + 14 modules
var serialize_product = __webpack_require__(57276);
// EXTERNAL MODULE: ./src/data/serialize-shopify-image.ts
var serialize_shopify_image = __webpack_require__(8145);
// EXTERNAL MODULE: ./src/lib/shopify/metafields/helpers.ts
var helpers = __webpack_require__(49344);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/data/storyblok/texts.ts + 1 modules
var texts = __webpack_require__(32725);
;// CONCATENATED MODULE: ./src/data/serialize-unlikely-variant-wb-variant.ts




function serializeUnlikelyVariantToWbVariant(variant, locale) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var isDefinitelyHidden = (0,helpers/* getMetafieldValue */.y)("variant.hide", variant === null || variant === void 0 ? void 0 : variant.metafields) === "true";
    if (isDefinitelyHidden) return null;
    var ref6;
    var price = (ref6 = (0,serialize_price/* default */.Z)(locale, variant === null || variant === void 0 ? void 0 : (ref = variant.price) === null || ref === void 0 ? void 0 : ref.currencyCode, variant === null || variant === void 0 ? void 0 : (ref1 = variant.price) === null || ref1 === void 0 ? void 0 : ref1.amount)) !== null && ref6 !== void 0 ? ref6 : null;
    var ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    return {
        id: (ref7 = variant === null || variant === void 0 ? void 0 : variant.id) !== null && ref7 !== void 0 ? ref7 : null,
        title: (ref8 = variant === null || variant === void 0 ? void 0 : variant.title) !== null && ref8 !== void 0 ? ref8 : null,
        price: price,
        unformattedPrice: (ref11 = {
            formattedPrice: price !== null && price !== void 0 ? price : null,
            amount: (ref9 = variant === null || variant === void 0 ? void 0 : (ref2 = variant.price) === null || ref2 === void 0 ? void 0 : ref2.amount) !== null && ref9 !== void 0 ? ref9 : null,
            currencyCode: (ref10 = variant === null || variant === void 0 ? void 0 : (ref3 = variant.price) === null || ref3 === void 0 ? void 0 : ref3.currencyCode) !== null && ref10 !== void 0 ? ref10 : null
        }) !== null && ref11 !== void 0 ? ref11 : null,
        sku: (ref12 = variant === null || variant === void 0 ? void 0 : variant.sku) !== null && ref12 !== void 0 ? ref12 : null,
        selectedOptions: (ref13 = variant === null || variant === void 0 ? void 0 : variant.selectedOptions) !== null && ref13 !== void 0 ? ref13 : null,
        availableForSale: (ref14 = (variant === null || variant === void 0 ? void 0 : variant.availableForSale) && (variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) > 0) !== null && ref14 !== void 0 ? ref14 : false,
        quantityAvailable: (ref15 = variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) !== null && ref15 !== void 0 ? ref15 : 0,
        // NOTE : This could break in some of the PDP cases
        // Like the alert or others
        currentlyNotInStock: (ref16 = (variant === null || variant === void 0 ? void 0 : variant.availableForSale) && (variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) <= 0) !== null && ref16 !== void 0 ? ref16 : false,
        compareAtPrice: (variant === null || variant === void 0 ? void 0 : variant.compareAtPrice) ? (0,serialize_price/* default */.Z)(locale, variant === null || variant === void 0 ? void 0 : (ref4 = variant.compareAtPrice) === null || ref4 === void 0 ? void 0 : ref4.currencyCode, variant === null || variant === void 0 ? void 0 : (ref5 = variant.compareAtPrice) === null || ref5 === void 0 ? void 0 : ref5.amount) : null,
        shops: (ref17 = serializeVariantShops(variant === null || variant === void 0 ? void 0 : variant.storeAvailability)) !== null && ref17 !== void 0 ? ref17 : [],
        image: (ref18 = variant === null || variant === void 0 ? void 0 : variant.image) !== null && ref18 !== void 0 ? ref18 : null
    };
}
function serializeVariantShops(shops) {
    var ref;
    var ref1;
    var availableShops = (ref1 = (ref = shops === null || shops === void 0 ? void 0 : shops.map(function(shop) {
        var ref;
        if ((shop === null || shop === void 0 ? void 0 : shop.available) && (shop === null || shop === void 0 ? void 0 : shop.quantityAvailable) > 0 && (shop === null || shop === void 0 ? void 0 : (ref = shop.location) === null || ref === void 0 ? void 0 : ref.name)) {
            var ref1;
            return {
                name: shop === null || shop === void 0 ? void 0 : (ref1 = shop.location) === null || ref1 === void 0 ? void 0 : ref1.name
            };
        } else {
            return null;
        }
    })) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var accordionItem = (availableShops === null || availableShops === void 0 ? void 0 : availableShops.length) > 0 ? [
        {
            headline: dictionary/* PRODUCT.EXPAND_PRODUCT_SHOPS */.c5.EXPAND_PRODUCT_SHOPS,
            text: (0,texts/* asComplexRichText */.SL)({
                items: (ref2 = availableShops === null || availableShops === void 0 ? void 0 : availableShops.map(function(shop) {
                    return {
                        type: "paragraph",
                        texts: [
                            shop === null || shop === void 0 ? void 0 : shop.name
                        ]
                    };
                })) !== null && ref2 !== void 0 ? ref2 : []
            })
        }, 
    ] : [];
    return accordionItem;
}

;// CONCATENATED MODULE: ./src/data/serialize-shopify-product-data.ts









function serializeShopifyProductData(param) {
    var isAdjustable = param.isAdjustable, adjustableOffsetValue = param.adjustableOffsetValue, productVariants = param.productVariants, shopifyProductId = param.shopifyProductId, productImages = param.productImages, media = param.media, locale = param.locale;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var variants = (ref = productVariants === null || productVariants === void 0 ? void 0 : productVariants.map(function(variant) {
        return serializeUnlikelyVariantToWbVariant(variant, locale);
    })) === null || ref === void 0 ? void 0 : ref.filter(Boolean);
    var isAdjusting = isAdjustable !== null && isAdjustable !== void 0 ? isAdjustable : false;
    var adjustableOffset = adjustableOffsetValue !== null && adjustableOffsetValue !== void 0 ? adjustableOffsetValue : 0;
    if (isAdjusting) {
        variants = serializeAdjustableVariants(variants, adjustableOffset);
    }
    // Order variants by value
    var orderedVariants = variants === null || variants === void 0 ? void 0 : variants.sort();
    var ref6, ref7;
    // set the lowest price as default variant
    var defaultVariant = (ref7 = (ref6 = (ref1 = orderedVariants === null || orderedVariants === void 0 ? void 0 : orderedVariants.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.availableForSale;
    })) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref6 !== void 0 ? ref6 : orderedVariants === null || orderedVariants === void 0 ? void 0 : orderedVariants[0]) !== null && ref7 !== void 0 ? ref7 : null;
    // Get the cheapest variant
    var cheapestVariant = variants ? (ref3 = (ref2 = (0,_to_consumable_array/* default */.Z)(variants)) === null || ref2 === void 0 ? void 0 : ref2.sort(function(a, b) {
        var ref, ref1;
        return ((ref = a.unformattedPrice) === null || ref === void 0 ? void 0 : ref.amount) - ((ref1 = b.unformattedPrice) === null || ref1 === void 0 ? void 0 : ref1.amount);
    })) === null || ref3 === void 0 ? void 0 : ref3[0] : null;
    var ref8;
    // Getting the price from the cheapest variant
    var ref9 = (ref8 = cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.unformattedPrice) !== null && ref8 !== void 0 ? ref8 : {}, currencyCode = ref9.currencyCode, amount = ref9.amount;
    var price = (0,serialize_price/* default */.Z)(locale, currencyCode, amount);
    var ref10;
    // Serializing Shopify Image
    var imageItems = (ref10 = (ref4 = productImages === null || productImages === void 0 ? void 0 : productImages.map(function(item) {
        var ref;
        return {
            video: null,
            image: (ref = (0,serialize_shopify_image/* default */.Z)(item)) !== null && ref !== void 0 ? ref : null
        };
    })) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
        return item && (item === null || item === void 0 ? void 0 : item.image);
    })) !== null && ref10 !== void 0 ? ref10 : null;
    var ref11, ref12, ref13, ref14;
    return {
        shopifyId: shopifyProductId !== null && shopifyProductId !== void 0 ? shopifyProductId : null,
        reference: (ref11 = defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.sku) !== null && ref11 !== void 0 ? ref11 : null,
        unformattedPrice: (ref12 = cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.unformattedPrice) !== null && ref12 !== void 0 ? ref12 : null,
        compareAtPrice: (ref13 = cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.compareAtPrice) !== null && ref13 !== void 0 ? ref13 : null,
        price: price,
        variants: orderedVariants !== null && orderedVariants !== void 0 ? orderedVariants : [],
        defaultVariant: defaultVariant,
        isAvailable: keepAvailableVariants(productVariants),
        items: imageItems !== null && imageItems !== void 0 ? imageItems : [],
        mediaItems: (ref14 = (ref5 = media === null || media === void 0 ? void 0 : media.map(function(media) {
            return serializeMediaItems(media);
        })) === null || ref5 === void 0 ? void 0 : ref5.filter(Boolean)) !== null && ref14 !== void 0 ? ref14 : null
    };
}
function serializeMediaItems(media) {
    var ref;
    var type = (ref = media === null || media === void 0 ? void 0 : media.mediaContentType) !== null && ref !== void 0 ? ref : null;
    switch(type){
        case serialize_product/* PRODUCT_MEDIA_IMAGE */.WK:
            {
                var image = media;
                return {
                    type: type,
                    image: (0,serialize_shopify_image/* default */.Z)(image),
                    video: null
                };
            }
        case serialize_product/* PRODUCT_MEDIA_VIDEO */.r7:
            {
                var ref1, ref2, ref3, ref4;
                var video = media;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    type: type
                }, (video === null || video === void 0 ? void 0 : (ref1 = video.sources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.url) ? {
                    video: {
                        src: video === null || video === void 0 ? void 0 : (ref3 = video.sources) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.url
                    }
                } : {}), {
                    image: null
                });
            }
        default:
            return null;
    }
}


/***/ }),

/***/ 76803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ fetchWishlistProducts; },
  "_": function() { return /* binding */ serializeWishlistProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/data/serialize-product-card.ts
var serialize_product_card = __webpack_require__(63472);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/lib/fetch-links.ts
var fetch_links = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/lib/storyblok.ts + 3 modules
var storyblok = __webpack_require__(57450);
;// CONCATENATED MODULE: ./src/lib/storyblok/get-by-uuid.ts






/**
 * fetches a story by its uuid if needed
 * @param {string | Record<string, any>} data - string | Record<string, any>
 * @param {any} [params] - The params to pass to the Storyblok.get method.
 * @returns A function that returns a promise that resolves to a story object.
 */ function getByUuid(uuid, params) {
    return _getByUuid.apply(this, arguments);
}
function _getByUuid() {
    _getByUuid = (0,_async_to_generator/* default */.Z)(function(uuid, params) {
        var ref, _instance, fetchData, ref1, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof uuid === "string")) return [
                        3,
                        5
                    ];
                    if (uuid === "") return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        storyblok/* default.getStory */.ZP.getStory(uuid, (0,_object_spread/* default */.Z)({
                            find_by: "uuid",
                            version: "published",
                            resolve_relations: (0,_to_consumable_array/* default */.Z)(fetch_links/* PRODUCT_CARD */.AA)
                        }, (_instance = storyblok/* pageSbParams.instance */.MG.instance) !== null && _instance !== void 0 ? _instance : {}, params))
                    ];
                case 2:
                    fetchData = _state.sent();
                    return [
                        2,
                        (ref1 = fetchData === null || fetchData === void 0 ? void 0 : (ref = fetchData.data) === null || ref === void 0 ? void 0 : ref.story) !== null && ref1 !== void 0 ? ref1 : null
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        uuid !== null && uuid !== void 0 ? uuid : null
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getByUuid.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/utils/shopify-ids.ts
var shopify_ids = __webpack_require__(54527);
;// CONCATENATED MODULE: ./src/data/serialize-wishlist-products.ts





function fetchWishlistProducts(_) {
    return _fetchWishlistProducts.apply(this, arguments);
}
function _fetchWishlistProducts() {
    _fetchWishlistProducts = (0,_async_to_generator/* default */.Z)(function(param) {
        var productFields, locale, products, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    productFields = param.productFields, locale = param.locale;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    if (!productFields || !(productFields === null || productFields === void 0 ? void 0 : productFields.length)) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        Promise.all(productFields.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(productField) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                serializeWishlistProductCard({
                                                    productField: productField,
                                                    locale: locale
                                                })
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(productField) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    products = _state.sent();
                    return [
                        2,
                        products.filter(Boolean)
                    ];
                case 3:
                    err = _state.sent();
                    console.error("Error fetching wishlist products", err);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchWishlistProducts.apply(this, arguments);
}
function serializeWishlistProductCard(_) {
    return _serializeWishlistProductCard.apply(this, arguments);
}
function _serializeWishlistProductCard() {
    _serializeWishlistProductCard = (0,_async_to_generator/* default */.Z)(function(param) {
        var productField, locale, ref, productId, variantId, uuid, fetchedProduct, serializedProduct;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    productField = param.productField, locale = param.locale;
                    productId = (0,shopify_ids/* addGIDPrefix */.iJ)("Product", productField === null || productField === void 0 ? void 0 : productField.empi);
                    variantId = (0,shopify_ids/* addGIDPrefix */.iJ)("ProductVariant", productField === null || productField === void 0 ? void 0 : productField.epi);
                    uuid = productField === null || productField === void 0 ? void 0 : (ref = productField.cprops) === null || ref === void 0 ? void 0 : ref.uuid;
                    if (!(0,shopify_ids/* isGID */.C9)("Product", productId) && !(0,shopify_ids/* isGID */.C9)("ProductVariant", variantId) && !uuid) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        getByUuid(uuid)
                    ];
                case 1:
                    fetchedProduct = _state.sent();
                    if (!fetchedProduct) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        (0,serialize_product_card/* default */.ZP)(fetchedProduct, locale, true)
                    ];
                case 2:
                    serializedProduct = _state.sent();
                    if (!serializedProduct) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        {
                            product: serializedProduct,
                            wishlistProductId: productField === null || productField === void 0 ? void 0 : productField.id,
                            variantId: variantId,
                            tags: []
                        }
                    ];
            }
        });
    });
    return _serializeWishlistProductCard.apply(this, arguments);
}


/***/ }),

/***/ 32725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SL": function() { return /* binding */ asComplexRichText; },
  "yG": function() { return /* binding */ asRichText; }
});

// UNUSED EXPORTS: ACCOUNT, ADDRESS, CITE, COLOR_HEXA, DATE, DESIGNER_NAME_1, DESIGNER_NAME_1_WYSIWYG, DESIGNER_NAME_2, DESIGNER_NAME_2_WYSIWYG, DESIGNER_NAME_3, DESIGNER_NAME_3_WYSIWYG, H1, H2, H3, HERO_CATEGORY_LINKS, HERO_CATEGORY_TITLE, IMAGE_LABEL, INLINE_CTA, INLINE_CTA_LINK, LABEL_PARAGRAPH, LINK, LONG_TITLE, MULTIPLE_PARAGRAPH, PIN, PLACEHOLDER, PRICE, PRIVACY_POLICY, PRODUCT, PRODUCT_TITLE, PRODUCT_VARIANT, QUOTE, ROUNDED_CTA, SINGLE_PARAGRAPH, SMALL_PARAGRAPH, SQUARED_CTA_LINK, STEP, SUBTITLE_PARAGRAPH, nElements

// EXTERNAL MODULE: ./src/components/UI/ProductCard/types.ts
var types = __webpack_require__(72206);
;// CONCATENATED MODULE: ./src/data/storyblok/images.ts
var SQUARE_IMAGE = {
    src: "/fake-assets/square.jpg",
    local: true,
    width: 661,
    height: 660,
    alt: null
};
var LANDSCAPE_IMAGE = {
    src: "/fake-assets/landscape.jpg",
    local: true,
    width: 1440,
    height: 820,
    alt: null
};
var PORTRAIT_IMAGE = {
    src: "/fake-assets/portrait.jpg",
    local: true,
    width: 688,
    height: 1100,
    alt: null
};
var PRODUCT_PORTRAIT_IMAGE = {
    src: "/fake-assets/product_portrait.jpg",
    local: true,
    width: 461,
    height: 614,
    alt: null
};
var PRODUCT_PORTRAIT_IMAGE_HOVER = {
    src: "/fake-assets/product_portrait_hover.jpg",
    local: true,
    width: 461,
    height: 614,
    alt: null
};
var PRODUCT_LANDSCAPE_IMAGE = {
    src: "/fake-assets/product_landscape.jpg",
    local: true,
    width: 808,
    height: 1076,
    alt: null
};
var FACEBOOK_ICON = {
    src: "/fake-assets/facebook-icon.png",
    local: true,
    width: 10,
    height: 10,
    alt: "facebook"
};
var SVG_IMAGE = {
    src: "/fake-assets/truck.svg",
    local: true,
    width: 14,
    height: 12,
    alt: "truck"
};
var LOGO_IMAGE = {
    src: "/fake-assets/logo.svg",
    local: true,
    width: 841,
    height: 1120,
    alt: null
};
var AUTH_IMAGE = {
    src: "/fake-assets/auth-image.jpg",
    local: true,
    width: 720,
    height: 900,
    alt: null
};
var DESIGNER_PORTRAIT_IMAGE_1 = {
    src: "/fake-assets/designer-portrait-1.jpg",
    local: true,
    width: 688,
    height: 1100,
    alt: null
};
var DESIGNER_PORTRAIT_IMAGE_2 = {
    src: "/fake-assets/designer-portrait-2.jpg",
    local: true,
    width: 454,
    height: 630,
    alt: null
};
var STORE_PORTRAIT_IMAGE_1 = {
    src: "/fake-assets/store-portrait-1.jpg",
    local: true,
    width: 461,
    height: 600,
    alt: null
};
var STORE_PORTRAIT_IMAGE_2 = {
    src: "/fake-assets/store-portrait-2.jpg",
    local: true,
    width: 461,
    height: 600,
    alt: null
};
var HERO_SLIDER_IMAGE_1 = {
    src: "/fake-assets/hero-slider-image-1.jpg",
    local: true,
    width: 960,
    height: 884,
    alt: null
};
var HERO_SLIDER_IMAGE_2 = {
    src: "/fake-assets/hero-slider-image-2.jpg",
    local: true,
    width: 960,
    height: 884,
    alt: null
};
var PUSH_CATEGORY_IMAGE_1 = {
    src: "/fake-assets/push-category-image-1.jpg",
    local: true,
    width: 1440,
    height: 810,
    alt: null
};
var PUSH_CATEGORY_IMAGE_2 = {
    src: "/fake-assets/push-category-image-2.jpg",
    local: true,
    width: 1440,
    height: 810,
    alt: null
};
var CARD_GENERIC_BIG_IMAGE_1 = {
    src: "/fake-assets/card_generic_big_1.jpg",
    local: true,
    width: 930,
    height: 620,
    alt: null
};
var CARD_GENERIC_REGULAR_IMAGE_1 = {
    src: "/fake-assets/card_generic_regular_1.jpg",
    local: true,
    width: 460,
    height: 620,
    alt: null
};
var PUSH_NEWSLETTER_IMAGE = {
    src: "/fake-assets/push_newsletter.jpg",
    local: true,
    width: 1440,
    height: 441,
    alt: null
};

;// CONCATENATED MODULE: ./src/data/storyblok/texts.ts


var nElements = function(n, element) {
    return Array.from(Array(n).keys()).map(function() {
        return element[0];
    });
};
var asRichText = function(param) {
    var _type = param.type, type = _type === void 0 ? "paragraph" : _type, _attrs = param.attrs, attrs = _attrs === void 0 ? {} : _attrs, texts = param.texts;
    return {
        type: "doc",
        content: [
            {
                type: type,
                attrs: attrs,
                content: texts === null || texts === void 0 ? void 0 : texts.map(function(text) {
                    return {
                        text: text,
                        type: "text"
                    };
                })
            }, 
        ]
    };
};
var asComplexRichText = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var ref;
    return {
        type: "doc",
        content: items === null || items === void 0 ? void 0 : items.map(function(item) {
            var ref1;
            return {
                type: item === null || item === void 0 ? void 0 : item.type,
                attrs: (ref = item === null || item === void 0 ? void 0 : item.attrs) !== null && ref !== void 0 ? ref : {},
                content: item === null || item === void 0 ? void 0 : (ref1 = item.texts) === null || ref1 === void 0 ? void 0 : ref1.map(function(text) {
                    return {
                        text: text,
                        type: "text"
                    };
                })
            };
        })
    };
};
var LINK = {
    href: "/"
};
var INLINE_CTA_LINK = {
    href: "/",
    children: "View all"
};
var SQUARED_CTA_LINK = {
    href: "/",
    children: "All Products"
};
var PLACEHOLDER = "Placeholder";
var INLINE_CTA = "Discover";
var ROUNDED_CTA = "Suscribe";
var COLOR_HEXA = "#B1B08D";
var PRICE = "14€";
var DATE = "10/03/2021";
var PRODUCT_VARIANT = "0.5 fl oz / 15mL";
var STEP = asRichText({
    type: "paragraph",
    texts: [
        "STEP 1"
    ]
});
var PIN = asRichText({
    type: "paragraph",
    texts: [
        "New"
    ]
});
var DESIGNER_NAME_1 = "Alexandra Jefford";
var DESIGNER_NAME_2 = "Sia Taylor";
var DESIGNER_NAME_3 = "Anette Ferdinanzes";
var IMAGE_LABEL = "Collection by Elhanatari";
var HERO_CATEGORY_TITLE = "Products";
var HERO_CATEGORY_LINKS = [
    {
        href: "/",
        children: "Fian\xe7ailles"
    },
    {
        href: "/",
        children: "Alliances"
    },
    {
        href: "/",
        children: "Diamant"
    },
    {
        href: "/",
        children: "Pierres de couleur"
    },
    {
        href: "/",
        children: "Perle"
    },
    {
        href: "/",
        children: "Sans pierre"
    },
    {
        href: "/",
        children: "Mixte"
    }, 
];
var H1 = asRichText({
    type: "heading",
    attrs: {
        level: 1
    },
    texts: [
        "Say hello."
    ]
});
var LONG_TITLE = asRichText({
    type: "heading",
    attrs: {
        level: 1
    },
    texts: [
        "Discover your personalized ritual for inner and outer beauty. Simply answer a few quick questions to get a tailored routine based on your skin type, lifestyle and goals", 
    ]
});
var H2 = asRichText({
    type: "heading",
    attrs: {
        level: 2
    },
    texts: [
        "New in"
    ]
});
var H3 = asRichText({
    type: "heading",
    attrs: {
        level: 2
    },
    texts: [
        "Say hello."
    ]
});
var LABEL_PARAGRAPH = asRichText({
    type: "paragraph",
    texts: [
        "Madrid, Spain"
    ]
});
var SUBTITLE_PARAGRAPH = asRichText({
    type: "paragraph",
    texts: [
        "Short Information"
    ]
});
var QUOTE = asRichText({
    type: "paragraph",
    texts: [
        "“Jewelry is my medium and to make it, by nature, is to be mindful of its techniques and the value of such fine materials. But this is secondary. The feeling I want to impart is one of radiance, in every sense: that of light, of emotion, of energy and, of course, that of beauty.”", 
    ]
});
var CITE = "ANA KHOURI";
var SMALL_PARAGRAPH = asRichText({
    type: "paragraph",
    texts: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius.", 
    ]
});
var SINGLE_PARAGRAPH = asRichText({
    type: "paragraph",
    texts: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius. Suspendisse pulvinar erat massa a purus nec. Nam arcu hac tortor nam est quam. Nisl egestas tristique nisi, faucibus vitae a. At neque, sit at accumsan, volutpat vel in. Turpis volutpat orci, quis id ultrices massa nunc. Condimentum dui fames amet sed dolor. At dui turpis scelerisque quis posuere. At et non tempor pretium. Blandit feugiat eu sit auctor consectetur elit elementum. Venenatis, netus urna bibendum egestas id aliquet odio.", 
    ]
});
var MULTIPLE_PARAGRAPH = asRichText({
    type: "paragraph",
    texts: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius. Suspendisse pulvinar erat massa a purus nec. Nam arcu hac tortor nam est quam. Nisl egestas tristique nisi, faucibus vitae a. At neque, sit at accumsan, volutpat vel in. Turpis volutpat orci, quis id ultrices massa nunc. Condimentum dui fames amet sed dolor. At dui turpis scelerisque quis posuere. At et non tempor pretium. Blandit feugiat eu sit auctor consectetur elit elementum. Venenatis, netus urna bibendum egestas id aliquet odio.",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius. Suspendisse pulvinar erat massa a purus nec. Nam arcu hac tortor nam est quam. Nisl egestas tristique nisi, faucibus vitae a. At neque, sit at accumsan, volutpat vel in. Turpis volutpat orci, quis id ultrices massa nunc. Condimentum dui fames amet sed dolor. At dui turpis scelerisque quis posuere. At et non tempor pretium. Blandit feugiat eu sit auctor consectetur elit elementum. Venenatis, netus urna bibendum egestas id aliquet odio.", 
    ]
});
var PRIVACY_POLICY = asRichText({
    type: "paragraph",
    texts: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius. Suspendisse pulvinar erat massa a purus nec. Nam arcu hac tortor nam est quam. Nisl egestas tristique nisi, faucibus vitae a. At neque, sit at accumsan, volutpat vel in. Turpis volutpat orci, quis id ultrices massa nunc. Condimentum dui fames amet sed dolor. At dui turpis scelerisque quis posuere. At et non tempor pretium. Blandit feugiat eu sit auctor consectetur elit elementum. Venenatis, netus urna bibendum egestas id aliquet odio.",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Hac iaculis tortor, augue magna cras sit aliquam varius. Suspendisse pulvinar erat massa a purus nec. Nam arcu hac tortor nam est quam. Nisl egestas tristique nisi, faucibus vitae a. At neque, sit at accumsan, volutpat vel in. Turpis volutpat orci, quis id ultrices massa nunc. Condimentum dui fames amet sed dolor. At dui turpis scelerisque quis posuere. At et non tempor pretium. Blandit feugiat eu sit auctor consectetur elit elementum. Venenatis, netus urna bibendum egestas id aliquet odio.", 
    ]
});
var ADDRESS = asComplexRichText({
    items: [
        {
            type: "paragraph",
            texts: [
                "Boulevard des Filles du Calvaire"
            ]
        },
        {
            type: "paragraph",
            texts: [
                "75003 Paris"
            ]
        },
        {
            type: "paragraph",
            texts: [
                "+33 (0)1 40 24 27 17"
            ]
        }, 
    ]
});
var ACCOUNT = {
    registerTitle: asRichText({
        type: "heading",
        attrs: {
            level: 2
        },
        texts: [
            "Lorem ipsum"
        ]
    }),
    registerLabel: "I. Label",
    title: asRichText({
        type: "heading",
        attrs: {
            level: 2
        },
        texts: [
            "Lorem ipsum"
        ]
    })
};
var PRODUCT = {
    name: "Garnet Earrings",
    designer: "Fernando Jorge",
    price: "$650",
    link: LINK,
    card_image: {
        loaderType: types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK,
        data: PORTRAIT_IMAGE
    },
    image: {
        loaderType: types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK,
        data: HERO_SLIDER_IMAGE_1
    }
};
var PRODUCT_TITLE = asRichText({
    type: "paragraph",
    texts: [
        "Flicker garnet bracelet"
    ]
});
var DESIGNER_NAME_1_WYSIWYG = asRichText({
    type: "paragraph",
    texts: [
        "Alexandra Jefford"
    ]
});
var DESIGNER_NAME_2_WYSIWYG = asRichText({
    type: "paragraph",
    texts: [
        "Sia Taylor"
    ]
});
var DESIGNER_NAME_3_WYSIWYG = asRichText({
    type: "paragraph",
    texts: [
        "Anette Ferdinanzes"
    ]
});


/***/ }),

/***/ 16211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ fromProductCardPropsToProductTrackingData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);
/* harmony import */ var _utils_number_as_boolean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98107);
/* harmony import */ var _utils_shopify_ids__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54527);




function fromProductCardPropsToProductTrackingData(product, param) {
    var listName = param.listName, listPosition = param.listPosition;
    var ref, ref1, ref2, ref3;
    var id = typeof (product === null || product === void 0 ? void 0 : product.shopifyId) === "string" ? (0,_utils_shopify_ids__WEBPACK_IMPORTED_MODULE_1__/* .getReferenceIdFromAdminId */ .aF)(product === null || product === void 0 ? void 0 : product.shopifyId) : product === null || product === void 0 ? void 0 : product.shopifyId;
    var variantId = typeof (product === null || product === void 0 ? void 0 : product.variantId) === "string" ? (0,_utils_shopify_ids__WEBPACK_IMPORTED_MODULE_1__/* .getReferenceIdFromAdminId */ .aF)(product === null || product === void 0 ? void 0 : product.variantId) : product === null || product === void 0 ? void 0 : product.variantId;
    var formattedId = "".concat(id ? id : "").concat(variantId ? variantId : "");
    var ref4, ref5;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        item_brand: _lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .PROJECT_NAME */ .O,
        item_sku: (ref4 = product === null || product === void 0 ? void 0 : product.sku) !== null && ref4 !== void 0 ? ref4 : "",
        quantity: (ref5 = product === null || product === void 0 ? void 0 : product.quantity) !== null && ref5 !== void 0 ? ref5 : 1
    }, (product === null || product === void 0 ? void 0 : product.name) && {
        item_name: product === null || product === void 0 ? void 0 : product.name
    }, (formattedId === null || formattedId === void 0 ? void 0 : formattedId.length) > 0 && {
        item_id: formattedId
    }, (product === null || product === void 0 ? void 0 : product.designer) && {
        productDesigner: product === null || product === void 0 ? void 0 : product.designer
    }, (product === null || product === void 0 ? void 0 : product.size) && {
        item_variant: product.size
    }, (product === null || product === void 0 ? void 0 : (ref = product.categories) === null || ref === void 0 ? void 0 : ref[0]) ? {
        item_category: product === null || product === void 0 ? void 0 : (ref1 = product.categories) === null || ref1 === void 0 ? void 0 : ref1[0]
    } : {}, (product === null || product === void 0 ? void 0 : (ref2 = product.categories) === null || ref2 === void 0 ? void 0 : ref2.length) > 1 && {
        item_subcategory: product === null || product === void 0 ? void 0 : (ref3 = product.categories) === null || ref3 === void 0 ? void 0 : ref3.join("-")
    }, (0,_utils_number_as_boolean__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(listPosition) && {
        index: listPosition
    }, (product === null || product === void 0 ? void 0 : product.priceAmount) ? {
        price: product === null || product === void 0 ? void 0 : product.priceAmount
    } : {});
}


/***/ }),

/***/ 69992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useGetProduct; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _lib_shopify_metafields__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88136);
/* harmony import */ var _lib_shopify_product_product_by_id__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73661);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79894);





function useGetProduct(param) {
    var id = param.id, locale = param.locale, _includeTags = param.includeTags, includeTags = _includeTags === void 0 ? false : _includeTags, _includeQuantityAvailable = param.includeQuantityAvailable, includeQuantityAvailable = _includeQuantityAvailable === void 0 ? false : _includeQuantityAvailable, _queryOptions = param.queryOptions, queryOptions = _queryOptions === void 0 ? {} : _queryOptions;
    return (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useShopQuery */ .D)({
        key: "get-product",
        queryOptions: queryOptions,
        variables: {
            id: id,
            includeTags: includeTags,
            includeQuantityAvailable: includeQuantityAvailable
        },
        queryFn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_lib_shopify_product_product_by_id__WEBPACK_IMPORTED_MODULE_1__/* .getSfProduct */ .e)({
                                id: id,
                                includeTags: includeTags,
                                includeQuantityAvailable: includeQuantityAvailable,
                                variantsFirst: 100,
                                storeAvailabilityFirst: 100,
                                includePrices: true,
                                mediaFirst: 100,
                                imagesFirst: 100,
                                includeDescriptionHtml: true,
                                includeFeaturedImage: true,
                                includeSeo: true,
                                includeSelectedOptions: true,
                                metafieldKeys: _lib_shopify_metafields__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_PRODUCT_METAFIELDS_KEYS */ .zb,
                                metafieldVariantsKeys: _lib_shopify_metafields__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_VARIANT_METAFIELDS_KEYS */ .RW,
                                locale: locale
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })
    });
}


/***/ }),

/***/ 62231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useProductStatusTagsValues; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/components/UI/ProductCardTags/index.tsx
var ProductCardTags = __webpack_require__(37145);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
;// CONCATENATED MODULE: ./src/utils/get-product-timed-status.ts

function msToDays(timestamp) {
    return timestamp / 1000 / 60 / 60 / 24;
}
function getProductTimedStatus(firstPublishedAtTime, lastBackInStockTime) {
    var dateNowTime = new Date(new Date().toISOString()).getTime();
    var isBackInstock = lastBackInStockTime ? msToDays(dateNowTime - lastBackInStockTime) < constants/* BACK_IN_STOCK_PRODUCT_DURATION */.U2 : false;
    var isNew = firstPublishedAtTime ? msToDays(dateNowTime - firstPublishedAtTime) < constants/* NEW_PRODUCT_DURATION */.LB : false;
    return {
        isBackInstock: isBackInstock,
        isNew: isNew
    };
}

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
;// CONCATENATED MODULE: ./src/hooks/useProductStatusTagsValues/index.ts





function useProductStatusTagsValues(tags) {
    var t = (0,lib/* useTranslate */.qM)();
    var isNew = tags.isNew, lastBackInStockTime = tags.lastBackInStockTime, isUniquePiece = tags.isUniquePiece, firstPublishedAtTime = tags.firstPublishedAtTime, isExclusivity = tags.isExclusivity;
    var isBackInstock = getProductTimedStatus(firstPublishedAtTime, lastBackInStockTime).isBackInstock;
    var statusTags = {
        isNew: isNew,
        isBackInstock: isBackInstock,
        isUniquePiece: isUniquePiece,
        isExclusivity: isExclusivity
    };
    return Object.entries(statusTags).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return value ? t(dictionary/* PRODUCT_STATUS */.eM[ProductCardTags/* PRODUCT_STATUSES */.N[key]]) : false;
    }).filter(function(item) {
        return item;
    });
}


/***/ }),

/***/ 90191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useWishlistQueryKey; },
/* harmony export */   "z": function() { return /* binding */ useGetWishList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36492);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98028);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15858);
/* harmony import */ var _data_serialize_wishlist_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76803);
/* harmony import */ var _hooks_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66794);
/* harmony import */ var _hooks_wishlist_useWishlistCookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91225);
/* harmony import */ var _lib_handle_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16445);








function useWishlistQueryKey() {
    var ref = (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGetCustomer */ ._)(), profile = ref.data;
    var wishlistCookie = (0,_hooks_wishlist_useWishlistCookie__WEBPACK_IMPORTED_MODULE_2__/* .useWishlistCookie */ ._)().wishlistCookie;
    return [
        "wishlist",
        {
            customerId: profile === null || profile === void 0 ? void 0 : profile.id,
            listID: wishlistCookie === null || wishlistCookie === void 0 ? void 0 : wishlistCookie.lid
        }
    ];
}
function useGetWishList() {
    var wishListQueryKey = useWishlistQueryKey();
    var cookieFromQuery = (0,_hooks_wishlist_useWishlistCookie__WEBPACK_IMPORTED_MODULE_2__/* .useWishlistCookie */ ._)().cookieFromQuery;
    var customerAccessToken = (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useCustomerContext */ .jt)().customerAccessToken;
    var locale = (0,_hooks_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)(wishListQueryKey, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, response, products;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_handle_api__WEBPACK_IMPORTED_MODULE_3__/* .getWishlist */ .sA)({
                            accessToken: customerAccessToken,
                            payload: cookieFromQuery
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        (0,_data_serialize_wishlist_products__WEBPACK_IMPORTED_MODULE_0__/* .fetchWishlistProducts */ .m)({
                            productFields: response === null || response === void 0 ? void 0 : (ref = response.list) === null || ref === void 0 ? void 0 : ref.listcontents,
                            locale: locale
                        })
                    ];
                case 2:
                    products = _state.sent();
                    return [
                        2,
                        {
                            wishlistLid: response === null || response === void 0 ? void 0 : (ref1 = response.list) === null || ref1 === void 0 ? void 0 : ref1.lid,
                            products: products,
                            userInfo: response === null || response === void 0 ? void 0 : (ref2 = response.list) === null || ref2 === void 0 ? void 0 : ref2.userinfo
                        }
                    ];
            }
        });
    }), {
        enabled: Boolean(customerAccessToken && (cookieFromQuery === null || cookieFromQuery === void 0 ? void 0 : cookieFromQuery.regid))
    });
}


/***/ }),

/***/ 98720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ PRODUCT_CARD; },
/* harmony export */   "Zy": function() { return /* binding */ PRODUCT_CATEGORIES; }
/* harmony export */ });
/* unused harmony exports PRODUCT, PRODUCT_CARDS, GLOBAL, ALGOLIA_FETCH_LINKS, ARCHIVE_PAGE, PRODUCT_PAGE, BLOG_ARTICLE_PAGE, PRESS_ARTICLE_PAGE, CART_PAGE, CATEGORY_PAGE, METAL_STONE_PAGE, DESIGNER_PAGE, PAGE, AUTHENTICATION_PAGE */
/* harmony import */ var _storyblok_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18685);

var DELIMITER = ",";
var ref;
var getResolveRelations = function(array) {
    var ref1;
    return (ref = (ref1 = array === null || array === void 0 ? void 0 : array.flat()) === null || ref1 === void 0 ? void 0 : ref1.join(DELIMITER)) !== null && ref !== void 0 ? ref : "";
};
var PRODUCT_CARD = [
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".designer"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".shopify_product"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".product_sustainability_tags"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".categories"), 
];
var PRODUCT = [
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".categories"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".product_metal"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".product_stone"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".product_selections"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".product_hidden_selections"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.PRODUCT */ .nI.PRODUCT, ".size_guide"), 
];
var PRODUCT_CATEGORY = [
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_SUBTYPES.PRODUCT_CATEGORY */ .ru.PRODUCT_CATEGORY, ".category_page_relation"), 
];
var DESIGNER = (/* unused pure expression or super */ null && ([]));
var FILTERS = [
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.DESIGNER */ .nI.DESIGNER, ".relation"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.METAL_STONE_PAGE */ .nI.METAL_STONE_PAGE, ".relation"),
    "".concat(_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_TYPES.CATEGORY_PAGE */ .nI.CATEGORY_PAGE, ".sub_navigation"),
    "filters.designers",
    "filters.stone",
    "filters.metal",
    "filters.categories",
    "filters.selections",
    "filters.hidden_selections", 
];
var BLOG = [];
var PRESS = [];
var GLOBALS = [];
var CART = [];
var AUTHENTICATION = [];
var PRODUCT_CARDS = getResolveRelations([
    PRODUCT_CARD
]);
var GLOBAL = getResolveRelations([
    GLOBALS
]);
var ALGOLIA_FETCH_LINKS = getResolveRelations([
    PRODUCT_CARD,
    PRODUCT_CATEGORY,
    PRODUCT, 
]);
var PRODUCT_CATEGORIES = getResolveRelations([
    PRODUCT_CATEGORY
]);
var ARCHIVE_PAGE = getResolveRelations([
    FILTERS
]);
var PRODUCT_PAGE = getResolveRelations([
    PRODUCT_CATEGORY,
    PRODUCT_CARD,
    PRODUCT, 
]);
var BLOG_ARTICLE_PAGE = getResolveRelations([
    BLOG
]);
var PRESS_ARTICLE_PAGE = getResolveRelations([
    PRESS
]);
var CART_PAGE = getResolveRelations([
    CART
]);
var CATEGORY_PAGE = getResolveRelations([
    FILTERS,
    PRODUCT_CATEGORY
]);
var METAL_STONE_PAGE = getResolveRelations([
    FILTERS
]);
var DESIGNER_PAGE = getResolveRelations([
    FILTERS
]);
var PAGE = getResolveRelations([]);
var AUTHENTICATION_PAGE = getResolveRelations([
    AUTHENTICATION
]);


/***/ }),

/***/ 51300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ processCartItems; }
/* harmony export */ });
/* unused harmony export addCustomObject */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);


function addCustomObject(key, value) {
    return value ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Array.isArray(key) ? key === null || key === void 0 ? void 0 : key.map(function(subkey) {
        return {
            key: subkey,
            value: value
        };
    }) : [
        {
            key: key,
            value: value
        }
    ]) : [];
}
function processCartItems(param) {
    var merchandiseId = param.merchandiseId, quantity = param.quantity, attributes = param.attributes;
    var ref, ref1, ref2, ref3;
    var ref4;
    var isAdjusted = (ref4 = attributes === null || attributes === void 0 ? void 0 : (ref = attributes.isAdjusting) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref4 !== void 0 ? ref4 : "false";
    var ref5, ref6, ref7, ref8, ref9, ref10;
    return merchandiseId ? [
        {
            merchandiseId: merchandiseId,
            quantity: quantity,
            attributes: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(attributes ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.name */ .n1.name, attributes === null || attributes === void 0 ? void 0 : attributes.name)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.designer */ .n1.designer, attributes === null || attributes === void 0 ? void 0 : attributes.designer)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.reference */ .n1.reference, attributes === null || attributes === void 0 ? void 0 : attributes.reference)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.slug */ .n1.slug, attributes === null || attributes === void 0 ? void 0 : attributes.slug)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.image */ .n1.image, attributes === null || attributes === void 0 ? void 0 : attributes.image)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.shopifyId */ .n1.shopifyId, attributes === null || attributes === void 0 ? void 0 : attributes.shopifyId)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.trackingData */ .n1.trackingData, (ref5 = attributes === null || attributes === void 0 ? void 0 : attributes.trackingData) !== null && ref5 !== void 0 ? ref5 : null)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.isPreOrder */ .n1.isPreOrder, (ref6 = attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.isPreOrder) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref6 !== void 0 ? ref6 : "false")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.isAdjusting */ .n1.isAdjusting, (ref7 = attributes === null || attributes === void 0 ? void 0 : (ref2 = attributes.isAdjusting) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref7 !== void 0 ? ref7 : "false")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.isUniqueSize */ .n1.isUniqueSize, (ref8 = attributes === null || attributes === void 0 ? void 0 : (ref3 = attributes.isUniqueSize) === null || ref3 === void 0 ? void 0 : ref3.toString()) !== null && ref8 !== void 0 ? ref8 : "false")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_ATTRIBUTES.selectedSize */ .n1.selectedSize, (ref9 = attributes === null || attributes === void 0 ? void 0 : attributes.selectedSize) !== null && ref9 !== void 0 ? ref9 : null)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((attributes === null || attributes === void 0 ? void 0 : attributes.lang) && isAdjusted === "true" ? addCustomObject(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_LOCALIZED_ATTRIBUTES */ .xN === null || _constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_LOCALIZED_ATTRIBUTES */ .xN === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_LOCALIZED_ATTRIBUTES */ .xN["adjustedSize_".concat(attributes === null || attributes === void 0 ? void 0 : attributes.lang)], (ref10 = attributes === null || attributes === void 0 ? void 0 : attributes.selectedSize) !== null && ref10 !== void 0 ? ref10 : null) : [])) : [])
        }, 
    ] : [];
}


/***/ }),

/***/ 49344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getMetafieldValue; }
/* harmony export */ });
/**
 * The function `getMetafieldValue` retrieves the value of a specific metafield using its key from a
 * given set of metafields.
 * @param {string} key - The `key` parameter is a string that represents the specific key of the
 * metafield whose value you want to retrieve.
 * @param {UnlikelyMetafields} metafields - Metafields are additional pieces of information that can be
 * associated with a particular object in a system. In this context, `metafields` likely refer to a
 * collection of metadata fields that contain various key-value pairs related to a specific object or
 * entity. The `UnlikelyMetafields` type suggests that these
 * @returns The function `getMetafieldValue` is returning the value of the metafield with the specified
 * key from the `metafields` object. If the metafield with the given key exists, it will return its
 * value. If the metafield does not exist or if the value is `undefined`, it will return `null`.
 */ function getMetafieldValue(key, metafields) {
    var ref;
    var ref1;
    return (ref1 = metafields === null || metafields === void 0 ? void 0 : (ref = metafields[key]) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : null;
}


/***/ }),

/***/ 88136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ SHOPIFY_VARIANT_METAFIELDS_KEYS; },
/* harmony export */   "zb": function() { return /* binding */ SHOPIFY_PRODUCT_METAFIELDS_KEYS; }
/* harmony export */ });
/* unused harmony exports SHOPIFY_PRODUCT_METAFIELDS, SHOPIFY_VARIANT_METAFIELDS */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var SHOPIFY_PRODUCT_METAFIELDS = [
    {
        namespace: "i18n",
        keys: [
            "title_en",
            "details_en",
            "details_fr",
            "description_en"
        ]
    }, 
];
var SHOPIFY_VARIANT_METAFIELDS = [
    {
        namespace: "variant",
        keys: [
            "hide"
        ]
    }, 
];
var SHOPIFY_PRODUCT_METAFIELDS_KEYS = SHOPIFY_PRODUCT_METAFIELDS.reduce(function(acc, metafield) {
    var computedKeys = metafield.keys.map(function(key) {
        return "".concat(metafield.namespace, ".").concat(key);
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(computedKeys));
}, []);
var SHOPIFY_VARIANT_METAFIELDS_KEYS = SHOPIFY_VARIANT_METAFIELDS.reduce(function(acc, metafield) {
    var computedKeys = metafield.keys.map(function(key) {
        return "".concat(metafield.namespace, ".").concat(key);
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(computedKeys));
}, []);


/***/ }),

/***/ 73661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getSfProduct; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);
/* harmony import */ var _lib_shopify_public_credentials__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61232);
/* harmony import */ var _unlikelystudio_commerce_connector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61202);
/* harmony import */ var _utils_locales__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40457);
/* harmony import */ var _utils_shopify_ids__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54527);









function getSfProduct(_param) {
    return _getSfProduct.apply(this, arguments);
}
function _getSfProduct() {
    _getSfProduct = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(_param) {
        var id, _locale, locale, _variantsFirst, variantsFirst, _includePrices, includePrices, _includeQuantityAvailable, includeQuantityAvailable, _includeTags, includeTags, _includeSelectedOptions, includeSelectedOptions, _mediaFirst, mediaFirst, _collectionsFirst, collectionsFirst, rest, formatIdIsValid, credentials, lang, country, ref, shopifyProducts;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = _param.id, _locale = _param.locale, locale = _locale === void 0 ? _lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_LOCALE */ .ZW : _locale, _variantsFirst = _param.variantsFirst, variantsFirst = _variantsFirst === void 0 ? 20 : _variantsFirst, _includePrices = _param.includePrices, includePrices = _includePrices === void 0 ? true : _includePrices, _includeQuantityAvailable = _param.includeQuantityAvailable, includeQuantityAvailable = _includeQuantityAvailable === void 0 ? true : _includeQuantityAvailable, _includeTags = _param.includeTags, includeTags = _includeTags === void 0 ? true : _includeTags, _includeSelectedOptions = _param.includeSelectedOptions, includeSelectedOptions = _includeSelectedOptions === void 0 ? true : _includeSelectedOptions, _mediaFirst = _param.mediaFirst, mediaFirst = _mediaFirst === void 0 ? 10 : _mediaFirst, _collectionsFirst = _param.collectionsFirst, collectionsFirst = _collectionsFirst === void 0 ? 10 : _collectionsFirst, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
                        "id",
                        "locale",
                        "variantsFirst",
                        "includePrices",
                        "includeQuantityAvailable",
                        "includeTags",
                        "includeSelectedOptions",
                        "mediaFirst",
                        "collectionsFirst"
                    ]);
                    formatIdIsValid = (0,_utils_shopify_ids__WEBPACK_IMPORTED_MODULE_3__/* .isGID */ .C9)("Product", id);
                    if (!formatIdIsValid) return [
                        3,
                        2
                    ];
                    credentials = (0,_lib_shopify_public_credentials__WEBPACK_IMPORTED_MODULE_1__/* .getStorefrontShopObject */ .u)();
                    lang = (0,_utils_locales__WEBPACK_IMPORTED_MODULE_2__/* .getShopifyLanguageCodeFromLocale */ .nb)(locale);
                    country = (0,_utils_locales__WEBPACK_IMPORTED_MODULE_2__/* .getCountryCode */ .so)(locale);
                    return [
                        4,
                        (0,_unlikelystudio_commerce_connector__WEBPACK_IMPORTED_MODULE_7__/* .sfProduct */ .e)({
                            storeUrl: credentials === null || credentials === void 0 ? void 0 : credentials.storeUrl,
                            storefrontAccessToken: credentials === null || credentials === void 0 ? void 0 : credentials.storefrontAccessToken
                        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            id: id,
                            variantsFirst: variantsFirst,
                            includePrices: includePrices,
                            includeQuantityAvailable: includeQuantityAvailable,
                            includeTags: includeTags,
                            includeSelectedOptions: includeSelectedOptions,
                            mediaFirst: mediaFirst,
                            collectionsFirst: collectionsFirst,
                            metafieldKeys: (ref = rest === null || rest === void 0 ? void 0 : rest.metafieldKeys) !== null && ref !== void 0 ? ref : [],
                            language: lang,
                            country: country
                        }, rest))
                    ];
                case 1:
                    shopifyProducts = _state.sent();
                    return [
                        2,
                        shopifyProducts === null || shopifyProducts === void 0 ? void 0 : shopifyProducts.product
                    ];
                case 2:
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getSfProduct.apply(this, arguments);
}


/***/ }),

/***/ 57450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ storyblok; },
  "MG": function() { return /* binding */ pageSbParams; }
});

// UNUSED EXPORTS: getStoryblokVersion

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/storyblok-js-client/dist/index.mjs
var dist = __webpack_require__(60315);
;// CONCATENATED MODULE: ./config/storyblok.json
var storyblok_namespaceObject = JSON.parse('{"i8":1751878218,"AB":1751881609440}');
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
;// CONCATENATED MODULE: ./src/utils/vercel-env.ts
/* provided dependency */ var process = __webpack_require__(34155);
var vercel_env_isVercelProduction = process.env.VERCEL_ENV === "production";
var isVercelPreview = process.env.VERCEL_ENV === "preview";
var isVercelDevelopment = process.env.VERCEL_ENV === "development";
var isLocked = process.env.NEXT_PUBLIC_ENABLE_AUTH === "true";
var hasUpstashEnabled = process.env.UPSTASH_ENABLED === "true";

;// CONCATENATED MODULE: ./src/lib/revalidate-next.ts

// 12 hours to global data file revalidate
var GLOBAL_DATA_FILE_REVALIDATE_TIME = (/* unused pure expression or super */ null && (12 * 60 * 60));
// 30 minutes to global data file development revalidate
var GLOBAL_DATA_FILE_DEVELOPMENT_REVALIDATE_TIME = (/* unused pure expression or super */ null && (30 * 60));
// 1 hour to revalidate
var REVALIDATE_TIME = 60 * 60;
// 1 second to debug revalidate
var DEBUG_REVALIDATE_TIME = 1;
// 30 second to revalidate
var DEVELOPMENT_TIME = 30;
// 30 second to revalidate
var NOT_FOUND_TIME = 30;
var getRevalidateTimeFromEnv = function() {
    return vercel_env_isVercelProduction ? REVALIDATE_TIME : DEVELOPMENT_TIME;
};
var getGlobalDataRevalidateTimeFromEnv = function() {
    return isVercelProduction ? GLOBAL_DATA_FILE_REVALIDATE_TIME : GLOBAL_DATA_FILE_DEVELOPMENT_REVALIDATE_TIME;
};

;// CONCATENATED MODULE: ./src/lib/storyblok.ts






var storyblokInstance = new dist/* default */.ZP({
    accessToken: "sznp1aqrVoy0bBKQEoUwugtt"
});
/* harmony default export */ var storyblok = (storyblokInstance);
var getStoryblokVersion = function() {
    var MS_REVALIDATE = getRevalidateTimeFromEnv() * 1000;
    var now = Date.now();
    var processed = now - MS_REVALIDATE;
    var version = processed > storyblok_namespaceObject.AB ? now : storyblok_namespaceObject.i8;
    return version;
};
var PageSbParams = /*#__PURE__*/ function() {
    "use strict";
    function PageSbParams() {
        (0,_class_call_check/* default */.Z)(this, PageSbParams);
        this.instance = {
            version: "published",
            language: constants/* DEFAULT_LANG */.Hj
        };
    }
    (0,_create_class/* default */.Z)(PageSbParams, [
        {
            key: "version",
            get: function get() {
                return this._version;
            },
            set: function set(value) {
                this._version = value;
            }
        },
        {
            key: "cv",
            get: function get() {
                return getStoryblokVersion();
            }
        },
        {
            key: "language",
            get: function get() {
                return this._lang;
            },
            set: function set(value) {
                this._lang = value;
            }
        },
        {
            key: "instance",
            get: function get() {
                return {
                    version: this.version,
                    cv: this.cv,
                    language: this.language,
                    resolve_level: 1
                };
            },
            set: function set(param) {
                var version = param.version, language = param.language;
                this.version = version;
                this.language = language;
            }
        }
    ]);
    return PageSbParams;
}();
var pageSbParams = new PageSbParams();


/***/ }),

/***/ 64349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isSizeOrDefaultVariantName; }
/* harmony export */ });
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);

/**
 * It checks if a string is a size or default variant name
 * @param {string} text - The text to check if it's a size or default variant name.
 * @returns A boolean value.
 */ function isSizeOrDefaultVariantName(text) {
    return _lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_VARIANT_SIZE_DEFAULT_KEYS.includes */ .Ij.includes(text.toLowerCase());
}


/***/ }),

/***/ 83771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getVariantFromSelectedOptions; }
/* harmony export */ });
/* unused harmony export getSelectedOptionsGroupedByType */
function getSelectedOptionsGroupedByType(variants) {
    return variants === null || variants === void 0 ? void 0 : variants.reduce(function(acc, variant) {
        var ref;
        variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptions) === null || ref === void 0 ? void 0 : ref.forEach(function(option) {
            if (variant === null || variant === void 0 ? void 0 : variant.availableForSale) {
                if (!acc[option.name]) {
                    acc[option.name] = [];
                }
                if (!acc[option.name].includes(option.value)) {
                    acc[option.name].push(option.value);
                }
            }
        });
        return acc;
    }, {});
}
function getVariantFromSelectedOptions(selectedOptions, variants) {
    return variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
        var ref;
        return variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptions) === null || ref === void 0 ? void 0 : ref.every(function(option) {
            return selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function(selectedOption) {
                return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) === option.name && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value;
            });
        });
    });
}


/***/ }),

/***/ 38080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hasInteracted":"styles_hasInteracted__h0LBC"};

/***/ }),

/***/ 57801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SliderControls":"styles_SliderControls__PcArE","buttonsWrapper":"styles_buttonsWrapper__Wq_g2","button":"styles_button__yryDZ","hasSmallerControls":"styles_hasSmallerControls__f1fJ3"};

/***/ }),

/***/ 49166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartToast":"styles_CartToast__DejzM","toastTop":"styles_toastTop__S4GCW","cartItem":"styles_cartItem__r_vcd","toastBottom":"styles_toastBottom__q2wWo","cta":"styles_cta__U9GVG"};

/***/ }),

/***/ 93641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartItem":"styles_CartItem__6zfLU","isMutating":"styles_isMutating__lV_DC","isMini":"styles_isMini__Se8NA","imageWrapper":"styles_imageWrapper__DjjgK","reference":"styles_reference__rAEW6","ratio":"styles_ratio__5LmhF","productInfos":"styles_productInfos__3_l6S","productInfosRows":"styles_productInfosRows__Ks9ge","productTopRow":"styles_productTopRow___IPWM","price":"styles_price__vLoUh","itemDesigner":"styles_itemDesigner__o_O8v","productLink":"styles_productLink__QQOLm","productInfo":"styles_productInfo__J_F0L","label":"styles_label__VQ_qE","sizeLabel":"styles_sizeLabel__M3EAT","selectedSize":"styles_selectedSize__LcMAD","productBottomRow":"styles_productBottomRow__fAxLM","removeCta":"styles_removeCta__e0Ngv","deleteConfirmation":"styles_deleteConfirmation__pJl_5","deleteTitle":"styles_deleteTitle__8alBE","deleteButtons":"styles_deleteButtons__BZORm","cta":"styles_cta__MKQGJ","hasInteracted":"styles_hasInteracted__A_KqU"};

/***/ }),

/***/ 60039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"IconCta":"styles_IconCta__EYiCe","disabled":"styles_disabled__WLFzd","loading":"styles_loading__8LIwR","icon":"styles_icon___2vNv","spinner":"styles_spinner__b_pYu"};

/***/ }),

/***/ 69235:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 69428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quickBuy":"styles_quickBuy__SLmeE","isLoading":"styles_isLoading__UFDms","button":"styles_button__djDcN","disabled":"styles_disabled__JZO_B","addToCart":"styles_addToCart__fNFOP","loaderWrapper":"styles_loaderWrapper__BuQso","spinner":"styles_spinner__bsk_t","variantsCta":"styles_variantsCta__6dLIo","variantQuickBuy":"styles_variantQuickBuy__9xZwm","mobileButton":"styles_mobileButton__JgIHn","fullWidth":"styles_fullWidth__BoiCY","displayBlock":"styles_displayBlock__XJWa_","icon":"styles_icon__9ryaU"};

/***/ }),

/***/ 41397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"styles_ProductCard__q4Ys8","imageRatio":"styles_imageRatio__MZxI3","imageContainer":"styles_imageContainer__EwbdC","overlay":"styles_overlay__gDxLx","productSlider":"styles_productSlider__BmMXD","slider":"styles_slider__PSxp9","sliderItem":"styles_sliderItem__NeWwF","big_grid":"styles_big_grid__Gta1l","regular":"styles_regular__7uWbp","small_grid":"styles_small_grid__LZYzC","medium_grid":"styles_medium_grid__P71qS","search_grid":"styles_search_grid__QCvzx","wishListCardMobile":"styles_wishListCardMobile__24Zj0","sliderControls":"styles_sliderControls__nuFfS","wishlistWrapper":"styles_wishlistWrapper__qeqeB","widthlistDetails":"styles_widthlistDetails__BWk_H","details":"styles_details__4INQy","wishlist":"styles_wishlist__ivSm3","tag":"styles_tag__0VEPr","inList":"styles_inList__5WaAK","quickBuy":"styles_quickBuy__w8uia","hoverImage":"styles_hoverImage__rjxYo","image":"styles_image__djB6m","bottom":"styles_bottom__LL0RH","bottomLeft":"styles_bottomLeft__MEFD0","price":"styles_price__h9eEl","creator":"styles_creator__U9kNh","hideOnSmallScreen":"styles_hideOnSmallScreen__n8kGD","hideOnLargeScreen":"styles_hideOnLargeScreen__ZGL6c"};

/***/ }),

/***/ 30694:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductCardTags":"styles_ProductCardTags__bM836","statusTags":"styles_statusTags__wJtyE","sustainabilityTags":"styles_sustainabilityTags__v1kvF","tag":"styles_tag__eX_2l"};

/***/ }),

/***/ 40609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductSlider":"styles_ProductSlider__OkQn3","arrow":"styles_arrow__FKs83","left":"styles_left__RtbwH","right":"styles_right__EmNV2","sliderControls":"styles_sliderControls__yMkg7","sliderButton":"styles_sliderButton__DlFdv","isActive":"styles_isActive__BLADH"};

/***/ }),

/***/ 66264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductTag":"styles_ProductTag__gj5nQ"};

/***/ }),

/***/ 16417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"WishlistIcon":"styles_WishlistIcon__OPvG6","hasInteracted":"styles_hasInteracted__H1Ull","icon":"styles_icon__aYXn4","isActive":"styles_isActive__F_4t_"};

/***/ })

}]);